import { Box, BoxProps, createIcon, ThemeTypings } from "@chakra-ui/react";

interface IconDotProps extends BoxProps {
  color: ThemeTypings["colors"];
}

export const IconDebitor = createIcon({
  displayName: "IconDebitor",
  viewBox: "0 0 32 32",
  path: (
    <>
      <path
        d="M10.6667 4.74999C9.09747 4.74999 7.59254 5.37336 6.48295 6.48295C5.37336 7.59254 4.75 9.09746 4.75 10.6667V21.3333C4.75 22.9025 5.37336 24.4075 6.48295 25.517C7.59254 26.6266 9.09747 27.25 10.6667 27.25H21.3333C22.9025 27.25 24.4075 26.6266 25.517 25.517C26.6266 24.4075 27.25 22.9025 27.25 21.3333V14.6667C27.25 14.2524 27.5858 13.9167 28 13.9167C28.4142 13.9167 28.75 14.2524 28.75 14.6667V21.3333C28.75 23.3004 27.9686 25.1868 26.5777 26.5777C25.1868 27.9686 23.3004 28.75 21.3333 28.75H10.6667C8.69964 28.75 6.81319 27.9686 5.42229 26.5777C4.0314 25.1868 3.25 23.3004 3.25 21.3333V10.6667C3.25 8.69964 4.0314 6.81318 5.42229 5.42229C6.81319 4.03139 8.69964 3.24999 10.6667 3.24999H17.3333C17.7475 3.24999 18.0833 3.58578 18.0833 3.99999C18.0833 4.41421 17.7475 4.74999 17.3333 4.74999H10.6667Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M16 12.75C14.3892 12.75 13.0833 14.0558 13.0833 15.6667C13.0833 17.2775 14.3892 18.5833 16 18.5833C17.6108 18.5833 18.9167 17.2775 18.9167 15.6667C18.9167 14.0558 17.6108 12.75 16 12.75ZM11.5833 15.6667C11.5833 13.2274 13.5607 11.25 16 11.25C18.4393 11.25 20.4167 13.2274 20.4167 15.6667C20.4167 18.1059 18.4393 20.0833 16 20.0833C13.5607 20.0833 11.5833 18.1059 11.5833 15.6667Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M12.3333 23.4167C11.5598 23.4167 10.8179 23.7239 10.2709 24.2709C9.72396 24.8179 9.41667 25.5598 9.41667 26.3333V27.6933C9.41667 28.1075 9.08088 28.4433 8.66667 28.4433C8.25245 28.4433 7.91667 28.1075 7.91667 27.6933V26.3333C7.91667 25.162 8.38199 24.0386 9.21028 23.2103C10.0386 22.382 11.162 21.9167 12.3333 21.9167H19.6667C20.838 21.9167 21.9614 22.382 22.7897 23.2103C23.618 24.0386 24.0833 25.162 24.0833 26.3333V27.6933C24.0833 28.1075 23.7475 28.4433 23.3333 28.4433C22.9191 28.4433 22.5833 28.1075 22.5833 27.6933V26.3333C22.5833 25.5598 22.276 24.8179 21.7291 24.2709C21.1821 23.7239 20.4402 23.4167 19.6667 23.4167H12.3333Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M18.4 7.50099C18.4 4.14384 21.1424 1.39999 24.499 1.39999C27.8554 1.39999 30.6 4.14569 30.6 7.50099C30.6 10.8566 27.8552 13.6 24.499 13.6L24.4976 13.6C23.5517 13.5978 22.6192 13.3755 21.7741 12.9506C20.9296 12.526 20.1954 11.9109 19.6296 11.1538C18.8333 10.1026 18.4016 8.81973 18.4 7.50099ZM19.6 7.50062C19.6013 8.55867 19.9479 9.58737 20.5871 10.4305L20.5897 10.434C21.0443 11.0427 21.6343 11.5372 22.3131 11.8784C22.9916 12.2195 23.7402 12.3981 24.4996 12.4C27.1932 12.3997 29.4 10.1932 29.4 7.50099C29.4 4.80829 27.1926 2.59999 24.499 2.59999C21.8057 2.59999 19.6002 4.80595 19.6 7.50062Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M24.499 4.15097C24.8304 4.15097 25.099 4.4196 25.099 4.75097V5.25097C25.099 5.58234 24.8304 5.85097 24.499 5.85097C24.1677 5.85097 23.899 5.58234 23.899 5.25097V4.75097C23.899 4.4196 24.1677 4.15097 24.499 4.15097Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M24.499 9.15097C24.8304 9.15097 25.099 9.4196 25.099 9.75097V10.251C25.099 10.5823 24.8304 10.851 24.499 10.851C24.1677 10.851 23.899 10.5823 23.899 10.251V9.75097C23.899 9.4196 24.1677 9.15097 24.499 9.15097Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M24.0521 4.64999L24.8741 4.64999C25.5102 4.64999 26.0228 5.00208 26.3109 5.4728C26.4839 5.75544 26.395 6.12479 26.1123 6.29776C25.8297 6.47074 25.4603 6.38183 25.2873 6.09919C25.1874 5.93591 25.0381 5.84999 24.8741 5.84999H24.0527C23.9424 5.85025 23.836 5.89073 23.7534 5.96385C23.6708 6.03705 23.6177 6.13792 23.6041 6.2475C23.5906 6.35708 23.6176 6.46783 23.68 6.55893C23.7423 6.64994 23.8357 6.71509 23.9426 6.74215L25.3466 7.09466C25.7384 7.1921 26.0818 7.42974 26.3105 7.76237C26.5395 8.09525 26.6385 8.50044 26.5891 8.9014C26.5396 9.30235 26.345 9.67131 26.0421 9.93858C25.7393 10.2057 25.3492 10.3527 24.9455 10.352H24.1241C23.4868 10.352 22.9729 9.99857 22.6849 9.52647C22.5123 9.24359 22.6018 8.87436 22.8846 8.70179C23.1675 8.52921 23.5368 8.61863 23.7093 8.90152C23.8093 9.06542 23.9595 9.15199 24.1241 9.15199H24.9461L24.9475 9.152C25.0582 9.15225 25.1652 9.11194 25.2482 9.0387C25.3312 8.96546 25.3845 8.86434 25.3981 8.75446C25.4117 8.64458 25.3845 8.53354 25.3218 8.44232C25.259 8.35109 25.1651 8.286 25.0576 8.25933L25.056 8.25893L23.65 7.90593C23.2594 7.80736 22.9175 7.56934 22.6898 7.23691C22.4622 6.90448 22.3638 6.50036 22.4132 6.10049C22.4625 5.70063 22.6562 5.33256 22.9579 5.06546C23.2595 4.79836 23.6492 4.65061 24.0521 4.64999Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </>
  ),
});

export const IconDot = ({ color, ...rest }: IconDotProps) => {
  const bc = color.split(".")[0];

  return (
    <Box
      bg={color}
      borderColor={`${bc}.200`}
      borderWidth="4px"
      rounded="full"
      boxSize="5"
      {...rest}
    />
  );
};

export const IconMenuMore = createIcon({
  displayName: "IconMenuMore",
  path: (
    <>
      <path
        d="M5.75012 3C4.24024 3 3.00012 4.24011 3.00012 5.75V18.25C3.00012 19.7599 4.24024 21 5.75012 21H18.2501C19.76 21 21.0001 19.7599 21.0001 18.25V5.75C21.0001 4.24011 19.76 3 18.2501 3H5.75012ZM5.75012 4.5H18.2501C18.9492 4.5 19.5001 5.05089 19.5001 5.75V18.25C19.5001 18.9491 18.9492 19.5 18.2501 19.5H5.75012C5.05101 19.5 4.50012 18.9491 4.50012 18.25V5.75C4.50012 5.05089 5.05101 4.5 5.75012 4.5ZM7.25012 7.5C7.15074 7.49859 7.05207 7.51696 6.95984 7.55402C6.86761 7.59108 6.78367 7.6461 6.7129 7.71588C6.64212 7.78566 6.58592 7.86882 6.54756 7.96051C6.50919 8.0522 6.48944 8.15061 6.48944 8.25C6.48944 8.34939 6.50919 8.4478 6.54756 8.53949C6.58592 8.63118 6.64212 8.71434 6.7129 8.78412C6.78367 8.8539 6.86761 8.90892 6.95984 8.94598C7.05207 8.98304 7.15074 9.00141 7.25012 9H16.7501C16.8495 9.00141 16.9482 8.98304 17.0404 8.94598C17.1326 8.90892 17.2166 8.8539 17.2873 8.78412C17.3581 8.71434 17.4143 8.63118 17.4527 8.53949C17.491 8.4478 17.5108 8.34939 17.5108 8.25C17.5108 8.15061 17.491 8.0522 17.4527 7.96051C17.4143 7.86882 17.3581 7.78566 17.2873 7.71588C17.2166 7.6461 17.1326 7.59108 17.0404 7.55402C16.9482 7.51696 16.8495 7.49859 16.7501 7.5H7.25012ZM7.25012 11.25C7.15074 11.2486 7.05207 11.267 6.95984 11.304C6.86761 11.3411 6.78367 11.3961 6.7129 11.4659C6.64212 11.5357 6.58592 11.6188 6.54756 11.7105C6.50919 11.8022 6.48944 11.9006 6.48944 12C6.48944 12.0994 6.50919 12.1978 6.54756 12.2895C6.58592 12.3812 6.64212 12.4643 6.7129 12.5341C6.78367 12.6039 6.86761 12.6589 6.95984 12.696C7.05207 12.733 7.15074 12.7514 7.25012 12.75H16.7501C16.8495 12.7514 16.9482 12.733 17.0404 12.696C17.1326 12.6589 17.2166 12.6039 17.2873 12.5341C17.3581 12.4643 17.4143 12.3812 17.4527 12.2895C17.491 12.1978 17.5108 12.0994 17.5108 12C17.5108 11.9006 17.491 11.8022 17.4527 11.7105C17.4143 11.6188 17.3581 11.5357 17.2873 11.4659C17.2166 11.3961 17.1326 11.3411 17.0404 11.304C16.9482 11.267 16.8495 11.2486 16.7501 11.25H7.25012ZM7.25012 15C7.15074 14.9986 7.05207 15.017 6.95984 15.054C6.86761 15.0911 6.78367 15.1461 6.7129 15.2159C6.64212 15.2857 6.58592 15.3688 6.54756 15.4605C6.50919 15.5522 6.48944 15.6506 6.48944 15.75C6.48944 15.8494 6.50919 15.9478 6.54756 16.0395C6.58592 16.1312 6.64212 16.2143 6.7129 16.2841C6.78367 16.3539 6.86761 16.4089 6.95984 16.446C7.05207 16.483 7.15074 16.5014 7.25012 16.5H16.7501C16.8495 16.5014 16.9482 16.483 17.0404 16.446C17.1326 16.4089 17.2166 16.3539 17.2873 16.2841C17.3581 16.2143 17.4143 16.1312 17.4527 16.0395C17.491 15.9478 17.5108 15.8494 17.5108 15.75C17.5108 15.6506 17.491 15.5522 17.4527 15.4605C17.4143 15.3688 17.3581 15.2857 17.2873 15.2159C17.2166 15.1461 17.1326 15.0911 17.0404 15.054C16.9482 15.017 16.8495 14.9986 16.7501 15H7.25012Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconSubscription = createIcon({
  displayName: "IconSubscription",
  viewBox: "0 0 24 24",

  // fill="currentColor"
  path: (
    <>
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M13.574 3.145C13.0545 3.05144 12.5279 3.00292 12 3C11.462 3 10.938 3.056 10.426 3.145"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M20.518 8.97299C20.871 9.94199 21.073 10.983 21.073 12.073"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M18.948 6.24298C18.2665 5.43421 17.4493 4.75032 16.533 4.22198"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M7.467 4.22198C6.55095 4.75059 5.73378 5.43444 5.052 6.24298"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M2.927 12.073C2.927 10.982 3.129 9.94099 3.482 8.97299"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M7.46698 19.924C8.36698 20.445 9.36398 20.814 10.426 21"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M3.48199 15.173C3.84217 16.1676 4.37351 17.0915 5.05199 17.903"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M13.574 21C14.6159 20.8179 15.6175 20.4537 16.533 19.924"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        d="M18.948 17.903C19.6265 17.0915 20.1578 16.1676 20.518 15.173"
      />
      <path
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
        fill="none"
        d="M14.986 10.577L12.467 8.814C12.3301 8.71827 12.1671 8.66693 12 8.66693C11.833 8.66693 11.6699 8.71827 11.533 8.814L9.01503 10.576C8.90777 10.651 8.82021 10.7508 8.75979 10.867C8.69938 10.9831 8.6679 11.1121 8.66803 11.243V14.517C8.66803 14.967 9.03303 15.332 9.48303 15.332H14.52C14.97 15.332 15.335 14.967 15.335 14.517V11.243C15.3343 11.1122 15.3022 10.9835 15.2415 10.8676C15.1808 10.7517 15.0932 10.6521 14.986 10.577Z"
      />
    </>
  ),
});

export const IconFlag = createIcon({
  displayName: "IconFlag",
  viewBox: "0 0 29 28",
  path: (
    <>
      <path
        d="M6.125 4.375L10.5 3.5L14 4.8125L17.5 6.125L21.875 5.25V16.625L19.25 17.5L14 16.625L10.5 15.75L6.125 16.625V4.375Z"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95705 4.58935V16.3275C4.95702 16.3317 4.95702 16.3359 4.95705 16.3401V24.5C4.95705 24.9833 5.3488 25.375 5.83205 25.375C6.3153 25.375 6.70705 24.9833 6.70705 24.5V16.8495C6.78855 16.8152 6.88617 16.7778 7.00124 16.7396C7.53887 16.5609 8.46511 16.3602 9.91539 16.3602C11.2572 16.3602 12.386 16.7967 13.6774 17.3065L13.7267 17.3259C14.9752 17.8189 16.3837 18.375 18.0821 18.375C19.7244 18.375 20.8683 18.0688 21.629 17.729C22.008 17.5597 22.2867 17.3844 22.4805 17.2402C22.5772 17.1682 22.6523 17.1043 22.7078 17.0532C22.7355 17.0277 22.7584 17.0055 22.7765 16.987C22.7856 16.9778 22.7935 16.9696 22.8003 16.9624L22.8096 16.9523L22.8136 16.9479L22.8154 16.9459L22.8163 16.9449C22.8164 16.9448 22.8165 16.9448 22.8148 16.9431C22.815 16.9429 22.8152 16.9426 22.8155 16.9424L22.8172 16.9439C22.9677 16.7759 23.0413 16.5658 23.0404 16.3567M23.0404 16.3567V4.66667C23.0404 4.32738 22.8442 4.01868 22.5371 3.87455C22.2371 3.73376 21.884 3.77478 21.6246 3.97881C21.6237 3.9794 21.6227 3.98012 21.6214 3.98098C21.6102 3.98866 21.5818 4.00735 21.5341 4.03377C21.4389 4.0865 21.2652 4.171 20.9962 4.26041C20.4586 4.43908 19.5323 4.63983 18.0821 4.63983C16.7403 4.63983 15.6114 4.20332 14.32 3.69353L14.2707 3.67409C13.0223 3.18115 11.6137 2.625 9.91539 2.625C8.27857 2.625 7.13955 2.91606 6.38231 3.23868C6.00475 3.39955 5.72668 3.56635 5.53281 3.70401C5.43604 3.77272 5.36075 3.83383 5.3049 3.88282C5.29098 3.89503 5.27828 3.90647 5.26676 3.91709C5.07731 4.0776 4.95705 4.31725 4.95705 4.585C4.95705 4.58645 4.95705 4.5879 4.95705 4.58935M21.2904 6.00107V15.9346C21.1966 15.9927 21.0728 16.0608 20.9153 16.1311C20.3999 16.3613 19.5022 16.625 18.0821 16.625C16.7403 16.625 15.6114 16.1885 14.32 15.6787L14.2707 15.6593C13.0223 15.1663 11.6137 14.6102 9.91539 14.6102C8.48064 14.6102 7.43934 14.787 6.70705 14.9989V5.02789C6.79919 4.97427 6.91853 4.91244 7.06825 4.84865C7.58705 4.62761 8.4897 4.375 9.91539 4.375C11.2572 4.375 12.386 4.81152 13.6774 5.3213L13.7267 5.34075C14.9752 5.83368 16.3837 6.38983 18.0821 6.38983C19.5168 6.38983 20.5581 6.21296 21.2904 6.00107Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconFlagHighlighted = createIcon({
  displayName: "Icon Flag",
  viewBox: "0 0 29 28",
  path: (
    <>
      <path
        d="M6.45703 4.375L10.832 3.5L14.332 4.8125L17.832 6.125L22.207 5.25V16.625L19.582 17.5L14.332 16.625L10.832 15.75L6.45703 16.625V4.375Z"
        fill="#3491AA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.28909 4.58935V16.3275C5.28905 16.3317 5.28905 16.3359 5.28909 16.3401V24.5C5.28909 24.9833 5.68084 25.375 6.16409 25.375C6.64733 25.375 7.03909 24.9833 7.03909 24.5V16.8495C7.12058 16.8152 7.2182 16.7778 7.33327 16.7396C7.8709 16.5609 8.79714 16.3602 10.2474 16.3602C11.5892 16.3602 12.718 16.7967 14.0095 17.3065L14.0587 17.3259C15.3072 17.8189 16.7157 18.375 18.4141 18.375C20.0564 18.375 21.2004 18.0688 21.961 17.729C22.3401 17.5597 22.6188 17.3844 22.8125 17.2402C22.9092 17.1682 22.9843 17.1043 23.0398 17.0532C23.0676 17.0277 23.0904 17.0055 23.1085 16.987C23.1176 16.9778 23.1255 16.9696 23.1323 16.9624L23.1416 16.9523L23.1456 16.9479L23.1475 16.9459L23.1484 16.9449C23.1484 16.9448 23.1485 16.9448 23.1468 16.9431C23.147 16.9429 23.1473 16.9426 23.1475 16.9424L23.1492 16.9439C23.2997 16.7759 23.3733 16.5658 23.3724 16.3567M23.3724 16.3567V4.66667C23.3724 4.32738 23.1763 4.01868 22.8691 3.87455C22.5691 3.73376 22.216 3.77478 21.9566 3.97881C21.9558 3.9794 21.9547 3.98012 21.9535 3.98098C21.9422 3.98866 21.9138 4.00735 21.8661 4.03377C21.7709 4.0865 21.5972 4.171 21.3282 4.26041C20.7906 4.43908 19.8644 4.63983 18.4141 4.63983C17.0723 4.63983 15.9435 4.20332 14.652 3.69353L14.6028 3.67409C13.3543 3.18115 11.9458 2.625 10.2474 2.625C8.61061 2.625 7.47158 2.91606 6.71435 3.23868C6.33678 3.39955 6.05871 3.56635 5.86484 3.70401C5.76808 3.77272 5.69278 3.83383 5.63693 3.88282C5.62301 3.89503 5.61031 3.90647 5.59879 3.91709C5.40934 4.0776 5.28909 4.31725 5.28909 4.585C5.28908 4.58645 5.28908 4.5879 5.28909 4.58935M21.6224 6.00107V15.9346C21.5286 15.9927 21.4048 16.0608 21.2474 16.1311C20.732 16.3613 19.8342 16.625 18.4141 16.625C17.0723 16.625 15.9435 16.1885 14.652 15.6787L14.6028 15.6593C13.3543 15.1663 11.9458 14.6102 10.2474 14.6102C8.81267 14.6102 7.77137 14.787 7.03909 14.9989V5.02789C7.13122 4.97427 7.25057 4.91244 7.40028 4.84865C7.91909 4.62761 8.82173 4.375 10.2474 4.375C11.5892 4.375 12.718 4.81152 14.0095 5.3213L14.0587 5.34075C15.3072 5.83368 16.7157 6.38983 18.4141 6.38983C19.8488 6.38983 20.8901 6.21296 21.6224 6.00107Z"
        fill="#00485E"
      />
    </>
  ),
});

export const IconMessages = createIcon({
  displayName: "IconMessages",
  viewBox: "0 0 29 28",
  path: (
    <>
      <path
        d="M4.16797 3.5H19.918V14H12.043L8.54297 17.5L8.10547 14H4.16797V3.5Z"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.53889 2.87092C3.97647 2.43333 4.56996 2.1875 5.1888 2.1875H18.3138C18.9326 2.1875 19.5261 2.43333 19.9637 2.87092C20.4013 3.3085 20.6471 3.90199 20.6471 4.52083V13.2708C20.6471 13.8897 20.4013 14.4832 19.9637 14.9207C19.5261 15.3583 18.9326 15.6042 18.3138 15.6042H12.8429L8.72419 19.7229C8.47394 19.9731 8.09759 20.048 7.77062 19.9126C7.44366 19.7771 7.23047 19.4581 7.23047 19.1042V15.6042H5.1888C4.56996 15.6042 3.97647 15.3583 3.53889 14.9207C3.1013 14.4832 2.85547 13.8897 2.85547 13.2708V4.52083C2.85547 3.90199 3.1013 3.3085 3.53889 2.87092ZM5.1888 3.9375C5.03409 3.9375 4.88572 3.99896 4.77632 4.10835C4.66693 4.21775 4.60547 4.36612 4.60547 4.52083V13.2708C4.60547 13.4255 4.66693 13.5739 4.77632 13.6833C4.88572 13.7927 5.03409 13.8542 5.1888 13.8542H8.10547C8.58872 13.8542 8.98047 14.2459 8.98047 14.7292V16.9917L11.8618 14.1104C12.0258 13.9464 12.2484 13.8542 12.4805 13.8542H18.3138C18.4685 13.8542 18.6169 13.7927 18.7263 13.6833C18.8357 13.5739 18.8971 13.4255 18.8971 13.2708V4.52083C18.8971 4.36612 18.8357 4.21775 18.7263 4.10835C18.6169 3.99896 18.4685 3.9375 18.3138 3.9375H5.1888Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8138 8.89583C21.8138 8.41258 22.2056 8.02083 22.6888 8.02083H24.1471C24.766 8.02083 25.3595 8.26667 25.7971 8.70425C26.2346 9.14184 26.4805 9.73533 26.4805 10.3542V19.1042C26.4805 19.723 26.2346 20.3165 25.7971 20.7541C25.3595 21.1917 24.766 21.4375 24.1471 21.4375H22.1055V24.9375C22.1055 25.2914 21.8923 25.6105 21.5653 25.7459C21.2384 25.8813 20.862 25.8065 20.6118 25.5562L16.493 21.4375H12.4805C11.9972 21.4375 11.6055 21.0457 11.6055 20.5625C11.6055 20.0793 11.9972 19.6875 12.4805 19.6875H16.8555C17.0875 19.6875 17.3101 19.7797 17.4742 19.9438L20.3555 22.8251V20.5625C20.3555 20.0793 20.7472 19.6875 21.2305 19.6875H24.1471C24.3018 19.6875 24.4502 19.626 24.5596 19.5166C24.669 19.4072 24.7305 19.2589 24.7305 19.1042V10.3542C24.7305 10.1995 24.669 10.0511 24.5596 9.94169C24.4502 9.83229 24.3018 9.77083 24.1471 9.77083H22.6888C22.2056 9.77083 21.8138 9.37908 21.8138 8.89583Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconMessagesHighlighted = createIcon({
  displayName: "IconMessages",
  viewBox: "0 0 28 28",
  path: (
    <>
      <path
        d="M3.5 3.5H19.25V14H11.375L7.875 17.5L7.4375 14H3.5V3.5Z"
        fill="#3491AA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.87092 2.87092C3.3085 2.43333 3.90199 2.1875 4.52083 2.1875H17.6458C18.2647 2.1875 18.8582 2.43333 19.2957 2.87092C19.7333 3.3085 19.9792 3.90199 19.9792 4.52083V13.2708C19.9792 13.8897 19.7333 14.4832 19.2957 14.9207C18.8582 15.3583 18.2647 15.6042 17.6458 15.6042H12.1749L8.05622 19.7229C7.80597 19.9731 7.42962 20.048 7.10265 19.9126C6.77569 19.7771 6.5625 19.4581 6.5625 19.1042V15.6042H4.52083C3.90199 15.6042 3.3085 15.3583 2.87092 14.9207C2.43333 14.4832 2.1875 13.8897 2.1875 13.2708V4.52083C2.1875 3.90199 2.43333 3.3085 2.87092 2.87092ZM4.52083 3.9375C4.36612 3.9375 4.21775 3.99896 4.10835 4.10835C3.99896 4.21775 3.9375 4.36612 3.9375 4.52083V13.2708C3.9375 13.4255 3.99896 13.5739 4.10835 13.6833C4.21775 13.7927 4.36612 13.8542 4.52083 13.8542H7.4375C7.92075 13.8542 8.3125 14.2459 8.3125 14.7292V16.9917L11.1938 14.1104C11.3579 13.9464 11.5804 13.8542 11.8125 13.8542H17.6458C17.8005 13.8542 17.9489 13.7927 18.0583 13.6833C18.1677 13.5739 18.2292 13.4255 18.2292 13.2708V4.52083C18.2292 4.36612 18.1677 4.21775 18.0583 4.10835C17.9489 3.99896 17.8005 3.9375 17.6458 3.9375H4.52083Z"
        fill="#00485E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1458 8.89583C21.1458 8.41258 21.5376 8.02083 22.0208 8.02083H23.4792C24.098 8.02083 24.6915 8.26667 25.1291 8.70425C25.5667 9.14184 25.8125 9.73533 25.8125 10.3542V19.1042C25.8125 19.723 25.5667 20.3165 25.1291 20.7541C24.6915 21.1917 24.098 21.4375 23.4792 21.4375H21.4375V24.9375C21.4375 25.2914 21.2243 25.6105 20.8973 25.7459C20.5704 25.8813 20.194 25.8065 19.9438 25.5562L15.8251 21.4375H11.8125C11.3293 21.4375 10.9375 21.0457 10.9375 20.5625C10.9375 20.0793 11.3293 19.6875 11.8125 19.6875H16.1875C16.4196 19.6875 16.6421 19.7797 16.8062 19.9438L19.6875 22.8251V20.5625C19.6875 20.0793 20.0793 19.6875 20.5625 19.6875H23.4792C23.6339 19.6875 23.7823 19.626 23.8916 19.5166C24.001 19.4072 24.0625 19.2589 24.0625 19.1042V10.3542C24.0625 10.1995 24.001 10.0511 23.8916 9.94169C23.7823 9.83229 23.6339 9.77083 23.4792 9.77083H22.0208C21.5376 9.77083 21.1458 9.37908 21.1458 8.89583Z"
        fill="#00485E"
      />
    </>
  ),
});

export const IconInbox = createIcon({
  displayName: "IconInbox",
  viewBox: "0 0 29 28",
  path: (
    <>
      <path
        d="M6.46094 4.375H22.2109L23.0859 16.625L14.3359 18.375L5.58594 16.625L6.46094 4.375Z"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.96094 8.16667C9.96094 7.68342 10.3527 7.29167 10.8359 7.29167H17.8359C18.3192 7.29167 18.7109 7.68342 18.7109 8.16667C18.7109 8.64992 18.3192 9.04167 17.8359 9.04167H10.8359C10.3527 9.04167 9.96094 8.64992 9.96094 8.16667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5026 4.375C8.11583 4.375 7.7449 4.52865 7.47141 4.80214C7.19792 5.07563 7.04427 5.44656 7.04427 5.83333V16.3333C7.04427 16.8166 6.65252 17.2083 6.16927 17.2083C5.68602 17.2083 5.29427 16.8166 5.29427 16.3333V5.83333C5.29427 4.98243 5.63229 4.16638 6.23397 3.5647C6.83565 2.96302 7.6517 2.625 8.5026 2.625H20.1693C21.0202 2.625 21.8362 2.96302 22.4379 3.5647C23.0396 4.16638 23.3776 4.98243 23.3776 5.83333V16.3333C23.3776 16.8166 22.9859 17.2083 22.5026 17.2083C22.0194 17.2083 21.6276 16.8166 21.6276 16.3333V5.83333C21.6276 5.44656 21.474 5.07563 21.2005 4.80214C20.927 4.52865 20.556 4.375 20.1693 4.375H8.5026Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.58594 17.2083C5.35387 17.2083 5.13131 17.3005 4.96722 17.4646C4.80312 17.6287 4.71094 17.8513 4.71094 18.0833V22.1667C4.71094 22.5534 4.86458 22.9244 5.13807 23.1979C5.41156 23.4714 5.7825 23.625 6.16927 23.625H22.5026C22.8894 23.625 23.2603 23.4714 23.5338 23.1979C23.8073 22.9244 23.9609 22.5534 23.9609 22.1667V18.0833C23.9609 17.8513 23.8688 17.6287 23.7047 17.4646C23.5406 17.3005 23.318 17.2083 23.0859 17.2083H21.1355V17.2083C20.7492 17.2085 20.3786 17.3618 20.1053 17.6348V17.6348L19.1384 18.6016V18.6016C18.8404 18.8997 18.4865 19.1363 18.097 19.2975C17.7076 19.4588 17.2902 19.5418 16.8688 19.5417V19.5417H11.8019C10.9519 19.5415 10.1365 19.204 9.53506 18.6032L8.39625 17.4644V17.4644C8.23228 17.3007 8.00985 17.2084 7.7781 17.2083V17.2083H5.58594ZM3.72978 16.2272C4.22207 15.7349 4.88974 15.4583 5.58594 15.4583H7.7781C8.47381 15.4585 9.14119 15.7348 9.63329 16.2266L10.7718 17.3651C11.0451 17.6379 11.4158 17.7915 11.8019 17.7917V17.7917H16.8688C17.0604 17.7917 17.2504 17.754 17.4274 17.6807C17.6045 17.6074 17.7653 17.4999 17.9008 17.3644L18.8681 16.3971C19.4695 15.7964 20.285 15.4585 21.1351 15.4583H23.0859C23.7821 15.4583 24.4498 15.7349 24.9421 16.2272C25.4344 16.7195 25.7109 17.3871 25.7109 18.0833V22.1667C25.7109 23.0176 25.3729 23.8336 24.7712 24.4353C24.1696 25.037 23.3535 25.375 22.5026 25.375H6.16927C5.31837 25.375 4.50232 25.037 3.90064 24.4353C3.29896 23.8336 2.96094 23.0176 2.96094 22.1667V18.0833C2.96094 17.3871 3.2375 16.7195 3.72978 16.2272Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconInboxHighlighted = createIcon({
  displayName: "Icon Inbox",
  viewBox: "0 0 29 28",
  path: (
    <>
      <path
        d="M6.79297 4.375H22.543L23.418 16.625L14.668 18.375L5.91797 16.625L6.79297 4.375Z"
        fill="#3491AA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.293 8.16667C10.293 7.68342 10.6847 7.29167 11.168 7.29167H18.168C18.6512 7.29167 19.043 7.68342 19.043 8.16667C19.043 8.64992 18.6512 9.04167 18.168 9.04167H11.168C10.6847 9.04167 10.293 8.64992 10.293 8.16667Z"
        fill="#00485E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83464 4.375C8.44786 4.375 8.07693 4.52865 7.80344 4.80214C7.52995 5.07563 7.3763 5.44656 7.3763 5.83333V16.3333C7.3763 16.8166 6.98455 17.2083 6.5013 17.2083C6.01805 17.2083 5.6263 16.8166 5.6263 16.3333V5.83333C5.6263 4.98243 5.96432 4.16638 6.566 3.5647C7.16768 2.96302 7.98373 2.625 8.83464 2.625H20.5013C21.3522 2.625 22.1683 2.96302 22.7699 3.5647C23.3716 4.16638 23.7096 4.98243 23.7096 5.83333V16.3333C23.7096 16.8166 23.3179 17.2083 22.8346 17.2083C22.3514 17.2083 21.9596 16.8166 21.9596 16.3333V5.83333C21.9596 5.44656 21.806 5.07563 21.5325 4.80214C21.259 4.52865 20.8881 4.375 20.5013 4.375H8.83464Z"
        fill="#00485E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91797 17.2083C5.6859 17.2083 5.46334 17.3005 5.29925 17.4646C5.13516 17.6287 5.04297 17.8513 5.04297 18.0833V22.1667C5.04297 22.5534 5.19661 22.9244 5.4701 23.1979C5.7436 23.4714 6.11453 23.625 6.5013 23.625H22.8346C23.2214 23.625 23.5923 23.4714 23.8658 23.1979C24.1393 22.9244 24.293 22.5534 24.293 22.1667V18.0833C24.293 17.8513 24.2008 17.6287 24.0367 17.4646C23.8726 17.3005 23.65 17.2083 23.418 17.2083H21.4675V17.2083C21.0812 17.2085 20.7106 17.3618 20.4373 17.6348V17.6348L19.4704 18.6016V18.6016C19.1724 18.8997 18.8185 19.1363 18.429 19.2975C18.0396 19.4588 17.6223 19.5418 17.2008 19.5417V19.5417H12.134C11.2839 19.5415 10.4685 19.204 9.86709 18.6032L8.72828 17.4644V17.4644C8.56431 17.3007 8.34188 17.2084 8.11014 17.2083V17.2083H5.91797ZM4.06181 16.2272C4.5541 15.7349 5.22178 15.4583 5.91797 15.4583H8.11014C8.80584 15.4585 9.47323 15.7348 9.96532 16.2266L11.1038 17.3651C11.3771 17.6379 11.7478 17.7915 12.134 17.7917V17.7917H17.2008C17.3924 17.7917 17.5824 17.754 17.7595 17.6807C17.9365 17.6074 18.0974 17.4999 18.2328 17.3644L19.2001 16.3971C19.8015 15.7964 20.6171 15.4585 21.4671 15.4583H23.418C24.1142 15.4583 24.7818 15.7349 25.2741 16.2272C25.7664 16.7195 26.043 17.3871 26.043 18.0833V22.1667C26.043 23.0176 25.7049 23.8336 25.1033 24.4353C24.5016 25.037 23.6855 25.375 22.8346 25.375H6.5013C5.6504 25.375 4.83435 25.037 4.23267 24.4353C3.63099 23.8336 3.29297 23.0176 3.29297 22.1667V18.0833C3.29297 17.3871 3.56953 16.7195 4.06181 16.2272Z"
        fill="#00485E"
      />
    </>
  ),
});

export const IconEmail = createIcon({
  displayName: "IconEmail",
  viewBox: "0 0 20 20",
  path: (
    <>
      <path
        d="M3.58331 16.25C3.16665 16.25 2.81248 16.1042 2.52081 15.8125C2.22915 15.5208 2.08331 15.1667 2.08331 14.75V5.25C2.08331 4.83333 2.22915 4.47917 2.52081 4.1875C2.81248 3.89583 3.16665 3.75 3.58331 3.75H16.4166C16.8333 3.75 17.1875 3.89583 17.4791 4.1875C17.7708 4.47917 17.9166 4.83333 17.9166 5.25V14.75C17.9166 15.1667 17.7708 15.5208 17.4791 15.8125C17.1875 16.1042 16.8333 16.25 16.4166 16.25H3.58331ZM9.99998 10.4583L3.33331 6.20833V14.75C3.33331 14.8194 3.35776 14.8786 3.40665 14.9275C3.45498 14.9758 3.51387 15 3.58331 15H16.4166C16.4861 15 16.5453 14.9758 16.5941 14.9275C16.6425 14.8786 16.6666 14.8194 16.6666 14.75V6.20833L9.99998 10.4583ZM9.99998 9.16667L16.5416 5H3.45831L9.99998 9.16667ZM3.33331 14.75C3.33331 14.8194 3.35776 14.8786 3.40665 14.9275C3.45498 14.9758 3.51387 15 3.58331 15H3.33331V14.75Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      />
    </>
  ),
});

export const IconMessage = createIcon({
  displayName: "IconMessage",
  viewBox: "0 0 20 20",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.05066 2.05066C2.36322 1.73809 2.78714 1.5625 3.22917 1.5625H12.6042C13.0462 1.5625 13.4701 1.73809 13.7827 2.05066C14.0952 2.36322 14.2708 2.78714 14.2708 3.22917V9.47917C14.2708 9.92119 14.0952 10.3451 13.7827 10.6577C13.4701 10.9702 13.0462 11.1458 12.6042 11.1458H8.69638L5.75444 14.0878C5.57569 14.2665 5.30687 14.32 5.07332 14.2233C4.83978 14.1265 4.6875 13.8986 4.6875 13.6458V11.1458H3.22917C2.78714 11.1458 2.36322 10.9702 2.05066 10.6577C1.73809 10.3451 1.5625 9.92119 1.5625 9.47917V3.22917C1.5625 2.78714 1.73809 2.36322 2.05066 2.05066ZM3.22917 2.8125C3.11866 2.8125 3.01268 2.8564 2.93454 2.93454C2.8564 3.01268 2.8125 3.11866 2.8125 3.22917V9.47917C2.8125 9.58967 2.8564 9.69565 2.93454 9.77379C3.01268 9.85193 3.11866 9.89583 3.22917 9.89583H5.3125C5.65768 9.89583 5.9375 10.1757 5.9375 10.5208V12.137L7.99556 10.0789C8.11277 9.96168 8.27174 9.89583 8.4375 9.89583H12.6042C12.7147 9.89583 12.8207 9.85193 12.8988 9.77379C12.9769 9.69565 13.0208 9.58967 13.0208 9.47917V3.22917C13.0208 3.11866 12.9769 3.01268 12.8988 2.93454C12.8207 2.8564 12.7147 2.8125 12.6042 2.8125H3.22917Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1042 6.35417C15.1042 6.00899 15.384 5.72917 15.7292 5.72917H16.7708C17.2129 5.72917 17.6368 5.90476 17.9493 6.21732C18.2619 6.52988 18.4375 6.95381 18.4375 7.39583V13.6458C18.4375 14.0879 18.2619 14.5118 17.9493 14.8243C17.6368 15.1369 17.2129 15.3125 16.7708 15.3125H15.3125V17.8125C15.3125 18.0653 15.1602 18.2932 14.9267 18.3899C14.6931 18.4867 14.4243 18.4332 14.2456 18.2544L11.3036 15.3125H8.4375C8.09232 15.3125 7.8125 15.0327 7.8125 14.6875C7.8125 14.3423 8.09232 14.0625 8.4375 14.0625H11.5625C11.7283 14.0625 11.8872 14.1283 12.0044 14.2456L14.0625 16.3036V14.6875C14.0625 14.3423 14.3423 14.0625 14.6875 14.0625H16.7708C16.8813 14.0625 16.9873 14.0186 17.0655 13.9405C17.1436 13.8623 17.1875 13.7563 17.1875 13.6458V7.39583C17.1875 7.28533 17.1436 7.17935 17.0655 7.10121C16.9873 7.02307 16.8813 6.97917 16.7708 6.97917H15.7292C15.384 6.97917 15.1042 6.69934 15.1042 6.35417Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconSearchHighlighted = createIcon({
  displayName: "Icon Search",
  viewBox: "0 0 20 20",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 16.9167L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43055 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L16.9375 15.7708C17.0903 15.9236 17.1667 16.1111 17.1667 16.3333C17.1667 16.5556 17.0833 16.75 16.9167 16.9167C16.7639 17.0694 16.5694 17.1458 16.3333 17.1458C16.0972 17.1458 15.9028 17.0694 15.75 16.9167ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconShortcut = createIcon({
  displayName: "IconShortcut",
  path: (
    <>
      <path
        d="M16.43 12.18C16.21 12.18 15.99 12.13 15.79 12.03C15.54 11.91 15.34 11.72 15.19 11.49C15.05 11.26 14.97 10.99 14.97 10.72V9.66996C14.39 9.75996 13.82 9.92996 13.3 10.18C12.55 10.54 11.86 11.07 11.33 11.72C11.13 11.96 10.79 12.05 10.5 11.95C10.2 11.84 10 11.56 10 11.24V10.89C10 9.32996 10.57 7.82996 11.62 6.65996C12.51 5.65996 13.68 4.97996 14.97 4.68996V3.45996C14.97 3.17996 15.05 2.91996 15.19 2.67996C15.33 2.44996 15.54 2.25996 15.79 2.13996C16.04 2.01996 16.31 1.96996 16.58 1.99996C16.85 2.02996 17.11 2.13996 17.32 2.30996L21.94 5.95996C22.11 6.08996 22.25 6.25996 22.34 6.45996C22.43 6.64996 22.48 6.86996 22.48 7.07996C22.48 7.28996 22.43 7.50996 22.34 7.69996C22.25 7.89996 22.11 8.06996 21.94 8.19996L17.32 11.85C17.1 12.02 16.85 12.13 16.57 12.16C16.52 12.16 16.47 12.16 16.41 12.16L16.43 12.18ZM15.72 8.09996C15.92 8.09996 16.11 8.17996 16.25 8.31996C16.39 8.45996 16.47 8.64996 16.47 8.84996V10.72L20.96 7.08996L16.4 3.48996L16.47 5.31996C16.47 5.69996 16.18 6.01996 15.8 6.06996C14.62 6.19996 13.53 6.76996 12.73 7.65996C12.29 8.14996 11.96 8.71996 11.75 9.33996C12.04 9.14996 12.34 8.97996 12.64 8.82996C13.59 8.37996 14.65 8.12996 15.7 8.10996H15.71L15.72 8.09996Z"
        fill="currentColor"
      />
      <path
        d="M15.75 22.5H7.75C6.21 22.5 4.77 21.9 3.68 20.82C2.59 19.73 2 18.29 2 16.75V8.74996C2 7.20996 2.6 5.76996 3.68 4.67996C4.77 3.59996 6.21 2.99996 7.75 2.99996H10.75C11.16 2.99996 11.5 3.33996 11.5 3.74996C11.5 4.15996 11.16 4.49996 10.75 4.49996H7.75C6.62 4.49996 5.55 4.93996 4.74 5.73996C3.94 6.53996 3.5 7.60996 3.5 8.74996V16.75C3.5 17.88 3.94 18.95 4.74 19.75C5.54 20.55 6.61 21 7.75 21H15.75C16.89 21 17.95 20.56 18.75 19.75C19.55 18.94 20 17.88 20 16.75V12.75C20 12.34 20.34 12 20.75 12C21.16 12 21.5 12.34 21.5 12.75V16.75C21.5 18.29 20.9 19.73 19.82 20.82C18.74 21.91 17.29 22.5 15.75 22.5Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconShare = createIcon({
  displayName: "IconShare",
  viewBox: "0 0 24 24",
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="M8.59 13.51L15.42 17.49" />
      <path d="M15.41 6.51L8.59 10.49" />
    </g>
  ),
});

export const IconTenantPrimary = createIcon({
  displayName: "IconTenantPrimary",
  viewBox: "0 0 25 25",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M6.68224 4.7848C7.18474 4.2823 7.86628 4 8.57692 4H18.3205C19.0312 4 19.7127 4.2823 20.2152 4.7848C20.7177 5.2873 21 5.96884 21 6.67949V20.3205C21 21.0312 20.7177 21.7127 20.2152 22.2152C19.7127 22.7177 19.0312 23 18.3205 23H4.67949C3.96884 23 3.2873 22.7177 2.7848 22.2152C2.2823 21.7127 2 21.0312 2 20.3205V9.60256C2 8.89192 2.2823 8.21038 2.7848 7.70788C3.2873 7.20538 3.96884 6.92308 4.67949 6.92308H5.89744V6.67949C5.89744 5.96884 6.17974 5.2873 6.68224 4.7848ZM5.89744 8.38462H4.67949C4.35647 8.38462 4.04668 8.51293 3.81827 8.74134C3.58986 8.96975 3.46154 9.27954 3.46154 9.60256V20.3205C3.46154 20.6435 3.58986 20.9533 3.81827 21.1817C4.04668 21.4101 4.35647 21.5385 4.67949 21.5385C5.00251 21.5385 5.3123 21.4101 5.54071 21.1817C5.76912 20.9533 5.89744 20.6435 5.89744 20.3205V8.38462ZM7.06617 21.5385C7.25687 21.1647 7.35897 20.7479 7.35897 20.3205V6.67949C7.35897 6.35647 7.48729 6.04668 7.7157 5.81827C7.94411 5.58986 8.2539 5.46154 8.57692 5.46154H18.3205C18.6435 5.46154 18.9533 5.58986 19.1817 5.81827C19.4101 6.04668 19.5385 6.35647 19.5385 6.67949V20.3205C19.5385 20.6435 19.4101 20.9533 19.1817 21.1817C18.9533 21.4101 18.6435 21.5385 18.3205 21.5385H7.06617Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.30769 8.62821C9.30769 8.22461 9.63487 7.89744 10.0385 7.89744H16.859C17.2626 7.89744 17.5897 8.22461 17.5897 8.62821C17.5897 9.0318 17.2626 9.35897 16.859 9.35897H10.0385C9.63487 9.35897 9.30769 9.0318 9.30769 8.62821Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.30769 12.5256C9.30769 12.122 9.63487 11.7949 10.0385 11.7949H16.859C17.2626 11.7949 17.5897 12.122 17.5897 12.5256C17.5897 12.9292 17.2626 13.2564 16.859 13.2564H10.0385C9.63487 13.2564 9.30769 12.9292 9.30769 12.5256Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.30769 16.4231C9.30769 16.0195 9.63487 15.6923 10.0385 15.6923H16.859C17.2626 15.6923 17.5897 16.0195 17.5897 16.4231C17.5897 16.8267 17.2626 17.1538 16.859 17.1538H10.0385C9.63487 17.1538 9.30769 16.8267 9.30769 16.4231Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="white"
        d="M18.8143 9.54433L16.3258 10.8522C16.2167 10.9096 16.0937 10.9353 15.9708 10.9264C15.8479 10.9175 15.7299 10.8744 15.6302 10.802C15.5305 10.7295 15.453 10.6306 15.4066 10.5164C15.3602 10.4022 15.3467 10.2774 15.3676 10.1559L15.843 7.3844L13.8286 5.42276C13.7404 5.33668 13.678 5.22764 13.6485 5.10798C13.619 4.98831 13.6235 4.86278 13.6616 4.74556C13.6997 4.62834 13.7698 4.52411 13.864 4.44463C13.9582 4.36515 14.0728 4.3136 14.1947 4.29579L16.9774 3.89118L18.2222 1.36854C18.2767 1.25793 18.3611 1.16479 18.4658 1.09965C18.5705 1.03452 18.6913 1 18.8146 1C18.9379 1 19.0587 1.03452 19.1634 1.09965C19.2681 1.16479 19.3524 1.25793 19.4069 1.36854L20.6512 3.89118L23.4338 4.29579C23.5559 4.31338 23.6706 4.36481 23.765 4.44426C23.8594 4.52371 23.9296 4.62801 23.9677 4.74532C24.0058 4.86263 24.0103 4.98827 23.9806 5.108C23.951 5.22774 23.8884 5.33678 23.8 5.42276L21.7856 7.3844L22.261 10.1559C22.2818 10.2774 22.2683 10.4022 22.2219 10.5164C22.1755 10.6306 22.0981 10.7295 21.9984 10.802C21.8987 10.8744 21.7807 10.9175 21.6577 10.9264C21.5348 10.9353 21.4119 10.9096 21.3028 10.8522L18.8143 9.54433ZM20.8372 11.7372L18.8143 10.674L16.7914 11.7372C16.5171 11.8815 16.2079 11.9461 15.8988 11.9238C15.5897 11.9015 15.293 11.7931 15.0423 11.6109C14.7916 11.4288 14.5969 11.18 14.4802 10.8929C14.3636 10.606 14.3296 10.2921 14.382 9.98684L14.7684 7.73382L13.1301 6.13841C12.9085 5.92208 12.7517 5.64807 12.6776 5.34734C12.6034 5.04661 12.6148 4.73114 12.7105 4.43657C12.8063 4.14199 12.9824 3.88004 13.2192 3.68031C13.4559 3.48058 13.7438 3.35103 14.0502 3.30628L16.3133 2.97723L17.3252 0.926684C17.4622 0.64886 17.6745 0.414224 17.9375 0.25058C18.2007 0.0868032 18.5046 0 18.8146 0C19.1246 0 19.4284 0.0868021 19.6917 0.25058C19.9547 0.41426 20.1668 0.648286 20.3038 0.926185L21.3154 2.97725L23.5764 3.30601C23.5762 3.30598 23.5766 3.30604 23.5764 3.30601C23.8832 3.35031 24.172 3.47969 24.4091 3.67934C24.6464 3.87911 24.8229 4.14135 24.9187 4.43633C25.0146 4.73131 25.0259 5.04723 24.9513 5.3483C24.8769 5.6491 24.7197 5.92306 24.4976 6.13918C24.4975 6.13937 24.4978 6.139 24.4976 6.13918L22.8601 7.73382L23.2465 9.98637C23.2989 10.2917 23.265 10.606 23.1483 10.8929C23.0317 11.18 22.8369 11.4287 22.5862 11.6109C22.3355 11.7931 22.0388 11.9015 21.7297 11.9238C21.4206 11.9461 21.1114 11.8815 20.8372 11.7372Z"
      />
      <path
        d="M18.8137 9.544L21.3028 10.8522C21.4119 10.9096 21.5348 10.9353 21.6577 10.9264C21.7807 10.9175 21.8987 10.8744 21.9984 10.802C22.0981 10.7295 22.1755 10.6306 22.2219 10.5164C22.2683 10.4022 22.2818 10.2774 22.261 10.1559L21.7856 7.3844L23.8 5.42276C23.8884 5.33678 23.951 5.22774 23.9806 5.108C24.0103 4.98827 24.0058 4.86263 23.9677 4.74532C23.9296 4.62801 23.8594 4.52371 23.765 4.44426C23.6706 4.36481 23.5559 4.31338 23.4338 4.29579L20.6512 3.89118L19.4069 1.36854C19.3524 1.25793 19.2681 1.16479 19.1634 1.09965C19.0587 1.03452 18.9379 1 18.8146 1C18.6913 1 18.5705 1.03452 18.4658 1.09965C18.3611 1.16479 18.2767 1.25793 18.2222 1.36854L16.9774 3.89118L14.1947 4.29579C14.0728 4.3136 13.9582 4.36515 13.864 4.44463C13.7698 4.52411 13.6997 4.62834 13.6616 4.74556C13.6235 4.86278 13.619 4.98831 13.6485 5.10798C13.678 5.22764 13.7404 5.33668 13.8286 5.42276L15.843 7.3844L15.3676 10.1559C15.3467 10.2774 15.3602 10.4022 15.4066 10.5164C15.453 10.6306 15.5305 10.7295 15.6302 10.802C15.7299 10.8744 15.8479 10.9175 15.9708 10.9264C16.0937 10.9353 16.2167 10.9096 16.3258 10.8522L18.8149 9.544H18.8137Z"
        fill="#F97316"
      />
    </>
  ),
});
export const IconTenantSecondary = createIcon({
  displayName: "IconTenantSecondary",
  viewBox: "0 0 25 25",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M6.68224 4.7848C7.18474 4.2823 7.86628 4 8.57692 4H18.3205C19.0312 4 19.7127 4.2823 20.2152 4.7848C20.7177 5.2873 21 5.96884 21 6.67949V20.3205C21 21.0312 20.7177 21.7127 20.2152 22.2152C19.7127 22.7177 19.0312 23 18.3205 23H4.67949C3.96884 23 3.2873 22.7177 2.7848 22.2152C2.2823 21.7127 2 21.0312 2 20.3205V9.60256C2 8.89192 2.2823 8.21038 2.7848 7.70788C3.2873 7.20538 3.96884 6.92308 4.67949 6.92308H5.89744V6.67949C5.89744 5.96884 6.17974 5.2873 6.68224 4.7848ZM5.89744 8.38462H4.67949C4.35647 8.38462 4.04668 8.51293 3.81827 8.74134C3.58986 8.96975 3.46154 9.27954 3.46154 9.60256V20.3205C3.46154 20.6435 3.58986 20.9533 3.81827 21.1817C4.04668 21.4101 4.35647 21.5385 4.67949 21.5385C5.00251 21.5385 5.3123 21.4101 5.54071 21.1817C5.76912 20.9533 5.89744 20.6435 5.89744 20.3205V8.38462ZM7.06617 21.5385C7.25687 21.1647 7.35897 20.7479 7.35897 20.3205V6.67949C7.35897 6.35647 7.48729 6.04668 7.7157 5.81827C7.94411 5.58986 8.2539 5.46154 8.57692 5.46154H18.3205C18.6435 5.46154 18.9533 5.58986 19.1817 5.81827C19.4101 6.04668 19.5385 6.35647 19.5385 6.67949V20.3205C19.5385 20.6435 19.4101 20.9533 19.1817 21.1817C18.9533 21.4101 18.6435 21.5385 18.3205 21.5385H7.06617Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.30769 8.62821C9.30769 8.22461 9.63487 7.89744 10.0385 7.89744H16.859C17.2626 7.89744 17.5897 8.22461 17.5897 8.62821C17.5897 9.0318 17.2626 9.35897 16.859 9.35897H10.0385C9.63487 9.35897 9.30769 9.0318 9.30769 8.62821Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.30769 12.5256C9.30769 12.122 9.63487 11.7949 10.0385 11.7949H16.859C17.2626 11.7949 17.5897 12.122 17.5897 12.5256C17.5897 12.9292 17.2626 13.2564 16.859 13.2564H10.0385C9.63487 13.2564 9.30769 12.9292 9.30769 12.5256Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M9.30769 16.4231C9.30769 16.0195 9.63487 15.6923 10.0385 15.6923H16.859C17.2626 15.6923 17.5897 16.0195 17.5897 16.4231C17.5897 16.8267 17.2626 17.1538 16.859 17.1538H10.0385C9.63487 17.1538 9.30769 16.8267 9.30769 16.4231Z"
      />
    </>
  ),
});

export const IconResident = createIcon({
  displayName: "IconResident",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        d="M9 21.5V16.1C9 15.54 9 15.26 9.109 15.046C9.20487 14.8578 9.35785 14.7049 9.546 14.609C9.76 14.5 10.04 14.5 10.6 14.5H13.4C13.96 14.5 14.24 14.5 14.454 14.609C14.6422 14.7049 14.7951 14.8578 14.891 15.046C15 15.26 15 15.54 15 16.1V21.5M2 10L11.04 3.22C11.384 2.962 11.556 2.833 11.745 2.783C11.9121 2.73892 12.0879 2.73892 12.255 2.783C12.444 2.833 12.615 2.962 12.96 3.22L22 10M4 8.5V18.3C4 19.42 4 19.98 4.218 20.408C4.40974 20.7843 4.71569 21.0903 5.092 21.282C5.52 21.5 6.08 21.5 7.2 21.5H16.8C17.92 21.5 18.48 21.5 18.908 21.282C19.2843 21.0903 19.5903 20.7843 19.782 20.408C20 19.98 20 19.42 20 18.3V8.5L13.92 3.94C13.232 3.424 12.887 3.165 12.51 3.066C12.1757 2.97784 11.8243 2.97784 11.49 3.066C11.113 3.166 10.768 3.424 10.08 3.94L4 8.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const IconViewOff = createIcon({
  displayName: "IconViewOff",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.015 3.4806C21.3018 3.77941 21.2921 4.25419 20.9933 4.54104L4.32665 20.541C4.02784 20.8279 3.55307 20.8182 3.26621 20.5194C2.97935 20.2206 2.98904 19.7458 3.28785 19.459L19.9545 3.45896C20.2533 3.1721 20.7281 3.18179 21.015 3.4806Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2833 8.78452C18.5275 8.44995 18.9967 8.37671 19.3313 8.62092C20.3626 9.37375 21.3156 10.2285 22.1758 11.1721L22.1788 11.1754C22.5474 11.5846 22.7514 12.1159 22.7514 12.6667C22.7514 13.2175 22.5474 13.7488 22.1788 14.158L22.1766 14.1604C19.8422 16.7295 15.9586 19.4791 11.9967 19.4167C11.0077 19.4232 10.0236 19.2772 9.07909 18.9838C8.68351 18.861 8.46243 18.4407 8.58528 18.0451C8.70813 17.6496 9.1284 17.4285 9.52397 17.5513C10.3238 17.7997 11.1571 17.923 11.9946 17.9167L12.0128 17.9168C15.336 17.9727 18.8395 15.6019 21.0652 13.153C21.1851 13.0194 21.2514 12.8462 21.2514 12.6667C21.2514 12.4873 21.1852 12.3143 21.0655 12.1807C20.2736 11.3122 19.3963 10.5255 18.4469 9.83249C18.1123 9.58827 18.0391 9.11908 18.2833 8.78452Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0021 5.91644C12.7852 5.90854 13.5662 6.00024 14.3261 6.18936C14.7281 6.28939 14.9728 6.69632 14.8728 7.09828C14.7728 7.50023 14.3659 7.745 13.9639 7.64497C13.3245 7.48586 12.6674 7.40906 12.0085 7.41645L11.9877 7.4164C8.72276 7.36213 5.20921 9.68053 2.93778 12.1784C2.8179 12.312 2.75159 12.4852 2.75159 12.6647C2.75159 12.844 2.81772 13.0169 2.93726 13.1505C3.61635 13.8936 4.35746 14.5776 5.15257 15.195C5.47973 15.4491 5.539 15.9202 5.28495 16.2474C5.0309 16.5745 4.55974 16.6338 4.23258 16.3798C3.36937 15.7095 2.56484 14.9668 1.82772 14.1599L1.82419 14.156C1.45557 13.7468 1.25159 13.2155 1.25159 12.6647C1.25159 12.1139 1.45558 11.5827 1.8242 11.1734L1.82651 11.1709C4.21254 8.54633 8.10496 5.85658 12.0021 5.91644Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.0834C11.6608 10.0833 11.3249 10.1501 11.0114 10.2799C10.698 10.4097 10.4132 10.5999 10.1733 10.8398C9.9334 11.0797 9.74313 11.3645 9.61335 11.6779C9.48357 11.9914 9.41681 12.3273 9.4169 12.6666C9.41702 13.0808 9.08132 13.4167 8.6671 13.4168C8.25289 13.4169 7.91702 13.0812 7.9169 12.667C7.91676 12.1307 8.02229 11.5996 8.22745 11.1041C8.43262 10.6086 8.73341 10.1584 9.11263 9.77915C9.49184 9.39993 9.94207 9.09914 10.4376 8.89398C10.9331 8.68881 11.4641 8.58328 12.0004 8.58343C12.4147 8.58354 12.7503 8.91941 12.7502 9.33363C12.7501 9.74784 12.4143 10.0835 12 10.0834Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3332 11.9157C15.7474 11.9156 16.0833 12.2513 16.0834 12.6655C16.0835 13.2019 15.978 13.733 15.7729 14.2285C15.5677 14.724 15.267 15.1743 14.8878 15.5536C14.5086 15.9329 14.0584 16.2338 13.5629 16.439C13.0674 16.6443 12.5364 16.75 12.0001 16.75C11.5858 16.75 11.2501 16.4142 11.2501 16C11.2501 15.5857 11.5858 15.25 12.0001 15.25C12.3394 15.25 12.6753 15.1831 12.9888 15.0532C13.3023 14.9234 13.5871 14.733 13.827 14.4931C14.0669 14.2531 14.2572 13.9683 14.3869 13.6547C14.5167 13.3412 14.5835 13.0052 14.5834 12.6659C14.5833 12.2517 14.919 11.9158 15.3332 11.9157Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconViewOn = createIcon({
  displayName: "IconViewOn",
  path: (
    <>
      <path
        d="M11.8525 18.9991C7.80837 18.9991 3.79223 16.1617 1.38143 13.5073C1.00727 13.0942 0.799906 12.5568 0.799561 11.9994C0.799216 11.442 1.00592 10.9044 1.37956 10.4908C3.7913 7.83547 7.8121 5 11.8646 5L12.0056 5.00093L12.1484 5C16.1878 5 20.2068 7.83547 22.6194 10.4889C23.395 11.3504 23.396 12.6468 22.6213 13.5064C20.2077 16.1627 16.1841 19 12.126 19L11.9869 18.9991H11.8525ZM11.8628 6.39907C8.2685 6.39907 4.62663 8.99747 2.41743 11.4297C2.27668 11.5861 2.19895 11.7891 2.19929 11.9994C2.19963 12.2098 2.27803 12.4125 2.4193 12.5684C4.62756 14.9997 8.2685 17.5991 11.8646 17.5991L11.9869 17.5981L12.1138 17.5991C15.723 17.5991 19.3714 14.9997 21.5825 12.5665C21.7233 12.4102 21.801 12.2072 21.8006 11.9968C21.8003 11.7865 21.7219 11.5837 21.5806 11.4279C19.3705 8.99747 15.7268 6.4 12.1325 6.4L11.9869 6.40093L11.8628 6.39907Z"
        fill="currentColor"
      />
      <path
        d="M11.9981 16.1982C11.4462 16.1995 10.8996 16.0914 10.3898 15.8801C9.88006 15.6688 9.41725 15.3585 9.02822 14.9671C8.63692 14.5781 8.32678 14.1153 8.11577 13.6055C7.90476 13.0956 7.7971 12.549 7.79902 11.9972C7.8005 10.8839 8.2435 9.81655 9.03086 9.02936C9.81822 8.24218 10.8856 7.79941 11.999 7.79818C13.1209 7.79818 14.1755 8.23498 14.9689 9.02738C15.3601 9.41629 15.6703 9.87896 15.8814 10.3886C16.0926 10.8982 16.2005 11.4447 16.199 11.9963C16.2008 12.5486 16.0928 13.0958 15.8815 13.6061C15.6702 14.1163 15.3597 14.5796 14.9679 14.969C14.5789 15.3599 14.1161 15.6698 13.6065 15.8808C13.0969 16.0918 12.5496 16.1997 11.9981 16.1982ZM11.9999 9.19818C10.4562 9.19818 9.19995 10.4535 9.19995 11.9972C9.19995 12.7448 9.49115 13.4486 10.0194 13.9768C10.2787 14.2377 10.5872 14.4445 10.927 14.5853C11.2668 14.7262 11.6312 14.7982 11.999 14.7972C12.7475 14.7972 13.4503 14.506 13.9786 13.9778C14.5069 13.4495 14.799 12.7458 14.799 11.9982C14.799 11.2478 14.5078 10.545 13.9786 10.0167C13.7192 9.75639 13.4108 9.55003 13.0712 9.40954C12.7315 9.26905 12.3675 9.19721 11.9999 9.19818Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconSignOut = createIcon({
  displayName: "IconSignOut",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.11005 12C9.11005 11.5858 9.44584 11.25 9.86005 11.25H20.0001C20.4143 11.25 20.7501 11.5858 20.7501 12C20.7501 12.4142 20.4143 12.75 20.0001 12.75H9.86005C9.44584 12.75 9.11005 12.4142 9.11005 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68605 4.75C5.90119 4.75 5.27905 5.37725 5.27905 6.135V17.8629C5.28021 18.0462 5.31745 18.2275 5.38866 18.3964C5.46009 18.5658 5.56429 18.7195 5.69527 18.8485C5.82626 18.9776 5.98145 19.0795 6.15193 19.1484C6.32242 19.2173 6.50483 19.2518 6.6887 19.25L6.69263 19.25L10.8606 19.231C11.2748 19.2291 11.6122 19.5634 11.614 19.9776C11.6159 20.3918 11.2817 20.7291 10.8675 20.731L6.7034 20.75L6.7012 20.75C6.32051 20.7534 5.94286 20.6818 5.58987 20.5391C5.23621 20.3962 4.91426 20.1848 4.64253 19.9171C4.3708 19.6493 4.15464 19.3306 4.00646 18.9791C3.85828 18.6276 3.781 18.2503 3.77906 17.8688L3.77905 17.865V6.135C3.77905 4.53475 5.08691 3.25 6.68605 3.25H11.0001C11.4143 3.25 11.7501 3.58579 11.7501 4C11.7501 4.41421 11.4143 4.75 11.0001 4.75H6.68605Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4697 7.46967C15.7626 7.17678 16.2375 7.17678 16.5304 7.46967L20.5304 11.4697C20.8233 11.7626 20.8233 12.2374 20.5304 12.5303L16.5304 16.5303C16.2375 16.8232 15.7626 16.8232 15.4697 16.5303C15.1768 16.2374 15.1768 15.7626 15.4697 15.4697L18.9394 12L15.4697 8.53033C15.1768 8.23744 15.1768 7.76256 15.4697 7.46967Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconDrag = createIcon({
  displayName: "IconDrag",
  path: (
    <path
      d="M3.90002 7.5C3.40296 7.5 3 7.90295 3 8.40002C3 8.89709 3.40295 9.30005 3.90002 9.30005H20.1C20.597 9.30005 21 8.89709 21 8.40002C21 7.90295 20.597 7.5 20.1 7.5H3.90002ZM3.9 11.1C3.40294 11.1 3 11.503 3 12C3 12.4971 3.40294 12.9 3.9 12.9H20.1C20.5971 12.9 21 12.4971 21 12C21 11.503 20.5971 11.1 20.1 11.1H12H3.9ZM3.9 14.7C3.40294 14.7 3 15.103 3 15.6C3 16.0971 3.40294 16.5 3.9 16.5H20.1C20.5971 16.5 21 16.0971 21 15.6C21 15.103 20.5971 14.7 20.1 14.7H3.9Z"
      fill="currentColor"
    />
  ),
});

export const IconFilters = createIcon({
  displayName: "IconFilters",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.17155 5.42128C3.80156 5.71284 3.75 5.91407 3.75 6V7.236C3.74968 7.54347 3.86268 7.84105 4.06741 8.07044L9.80941 14.5004C9.93216 14.6379 10 14.8157 10 15V19C10 19.3315 10.1317 19.6495 10.3661 19.8839C10.6005 20.1183 10.9185 20.25 11.25 20.25H12.75C13.0815 20.25 13.3995 20.1183 13.6339 19.8839C13.8683 19.6495 14 19.3315 14 19V15C14 14.8157 14.0678 14.6379 14.1905 14.5005L19.9325 8.06954C19.9325 8.06952 19.9325 8.06956 19.9325 8.06954C20.137 7.84047 20.25 7.5441 20.25 7.23704V6C20.25 5.91407 20.1984 5.71284 19.8284 5.42128C19.4669 5.13638 18.8973 4.84702 18.1266 4.59014C16.593 4.07899 14.4268 3.75 12 3.75C9.57318 3.75 7.40697 4.07899 5.87341 4.59014C5.1027 4.84702 4.53309 5.13638 4.17155 5.42128ZM5.3991 3.16711C7.12303 2.59251 9.45682 2.25 12 2.25C14.5432 2.25 16.877 2.59251 18.6009 3.16711C19.459 3.4531 20.2075 3.81018 20.7569 4.24313C21.2978 4.66941 21.75 5.25743 21.75 6V7.23696C21.75 7.23697 21.75 7.23695 21.75 7.23696C21.75 7.91252 21.5014 8.56449 21.0515 9.06846L15.5 15.2861V19C15.5 19.7293 15.2103 20.4288 14.6945 20.9445C14.1788 21.4603 13.4793 21.75 12.75 21.75H11.25C10.5207 21.75 9.82118 21.4603 9.30546 20.9445C8.78973 20.4288 8.5 19.7293 8.5 19V15.2861L2.94859 9.06956C2.49816 8.56498 2.24939 7.91201 2.25 7.23564C2.25 7.2355 2.25 7.23578 2.25 7.23564V6C2.25 5.25743 2.70219 4.66941 3.24314 4.24313C3.79254 3.81018 4.54105 3.4531 5.3991 3.16711Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.25C3.41421 5.25 3.75 5.58579 3.75 6C3.75 6.08593 3.80156 6.28716 4.17155 6.57872C4.53309 6.86362 5.1027 7.15298 5.87341 7.40986C7.40697 7.92101 9.57318 8.25 12 8.25C14.4268 8.25 16.593 7.92101 18.1266 7.40986C18.8973 7.15298 19.4669 6.86362 19.8284 6.57872C20.1984 6.28716 20.25 6.08593 20.25 6C20.25 5.58579 20.5858 5.25 21 5.25C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.74257 21.2978 7.33059 20.7569 7.75687C20.2075 8.18982 19.459 8.5469 18.6009 8.83289C16.877 9.40749 14.5432 9.75 12 9.75C9.45682 9.75 7.12303 9.40749 5.3991 8.83289C4.54105 8.5469 3.79254 8.18982 3.24314 7.75687C2.70219 7.33059 2.25 6.74257 2.25 6C2.25 5.58579 2.58579 5.25 3 5.25Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconSavedView = createIcon({
  displayName: "IconSavedView",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2975 18.6484C10.4809 18.8635 10.7539 19 11.0588 19H21C21.5523 19 22 18.5523 22 18V13.0769C22 12.7814 21.8718 12.5159 21.6681 12.3328C21.491 12.1737 21.2568 12.0769 21 12.0769H11.0588C10.802 12.0769 10.5678 12.1737 10.3908 12.3328C10.3879 12.3353 10.3851 12.3379 10.3824 12.3404C10.1835 12.5232 10.0588 12.7855 10.0588 13.0769V18C10.0588 18.2474 10.1486 18.4738 10.2975 18.6484ZM10.3908 10.6672C10.5678 10.8263 10.802 10.9231 11.0588 10.9231H21C21.2568 10.9231 21.491 10.8263 21.6681 10.6672C21.8718 10.4841 22 10.2186 22 9.92308V5C22 4.44771 21.5523 4 21 4H11.0588C10.7539 4 10.4809 4.13646 10.2975 4.35165C10.1486 4.52623 10.0588 4.75262 10.0588 5V9.92308C10.0588 10.2145 10.1835 10.4768 10.3824 10.6596C10.3851 10.6621 10.3879 10.6647 10.3908 10.6672ZM7.64372 18.6484C7.79253 18.4738 7.88235 18.2474 7.88235 18V5C7.88235 4.75262 7.79253 4.52623 7.64372 4.35164C7.4603 4.13646 7.18726 4 6.88235 4H3C2.44772 4 2 4.44772 2 5V18C2 18.5523 2.44772 19 3 19H6.88235C7.18726 19 7.4603 18.8635 7.64372 18.6484ZM20.5 17.5H11.5588V13.5769H20.5V17.5ZM6.38235 17.5V5.5H3.5V17.5H6.38235ZM11.5588 9.42308H20.5V5.5H11.5588V9.42308Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconLogo = createIcon({
  displayName: "IconLogo",
  viewBox: "0 0 40 40",
  path: (
    <>
      <g clipPath="url(#clip0_728_53718)">
        <path
          d="M28.2221 27.0698H11.7852V29.4398H28.2221V27.0698Z"
          fill="currentColor"
        />
        <path
          d="M28.2221 18.8955H11.7852V21.2655H28.2221V18.8955Z"
          fill="currentColor"
        />
        <path
          d="M28.2221 14.2121L19.9996 11.955L11.7852 14.2121V11.8421L19.9996 9.58496L28.2221 11.8421V14.2121Z"
          fill="currentColor"
        />
        <path
          d="M20.0323 2.37806C16.5437 2.37168 13.1316 3.40043 10.2279 5.33411C7.3243 7.2678 5.05961 10.0195 3.72052 13.2408C2.38144 16.4622 2.02818 20.0084 2.70544 23.4306C3.38271 26.8529 5.06005 29.9972 7.52517 32.4657C9.99028 34.9342 13.1323 36.6159 16.5536 37.2979C19.9749 37.9798 23.5216 37.6314 26.7448 36.2968C29.968 34.9621 32.7228 32.7012 34.6605 29.8002C36.5981 26.8992 37.6316 23.4886 37.63 20C37.6236 15.3325 35.7683 10.8577 32.4701 7.55499C29.172 4.25231 24.6997 2.39085 20.0323 2.37806ZM20.0323 40C16.0753 40.0064 12.2053 38.8388 8.91208 36.6451C5.61885 34.4513 3.05039 31.33 1.53169 27.676C0.0129907 24.0221 -0.387679 19.9997 0.38038 16.118C1.14844 12.2362 3.05071 8.66956 5.84647 5.86929C8.64223 3.06901 12.2058 1.16099 16.0863 0.386669C19.9668 -0.387652 23.9898 0.00652696 27.6462 1.51933C31.3026 3.03213 34.4281 5.59556 36.6271 8.88523C38.8262 12.1749 40 16.043 40 20C39.9958 25.2974 37.8917 30.3771 34.1488 34.126C30.406 37.8749 25.3297 39.9872 20.0323 40Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_728_53718">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
});

export const IconLogoFull = createIcon({
  displayName: "IconLogoFull",
  viewBox: "0 0 149 32",
  path: (
    <>
      <g clipPath="url(#clip0_775_77040)">
        <path
          d="M48.0009 15.4586C48.0077 15.1074 47.9408 14.7588 47.8047 14.4353C47.6685 14.1118 47.4661 13.8208 47.2107 13.5811C46.9552 13.3414 46.6524 13.1585 46.322 13.0442C45.9915 12.9299 45.6408 12.8869 45.2927 12.9178C44.6043 12.9086 43.9392 13.1684 43.4376 13.6423C42.936 14.1163 42.637 14.7674 42.6037 15.4586H48.0009ZM49.9308 18.6135C49.6298 19.5478 49.0347 20.3583 48.2351 20.9227C47.4356 21.4872 46.4751 21.775 45.4985 21.7427C42.8482 21.7427 40.5323 19.8031 40.5323 16.4477C40.5323 13.3316 42.771 11.211 45.2477 11.211C48.284 11.211 49.9887 13.3122 49.9887 16.3831C49.991 16.5992 49.9781 16.8153 49.9501 17.0296H42.5394C42.5307 17.426 42.6017 17.8201 42.748 18.1883C42.8944 18.5565 43.1131 18.8912 43.3912 19.1725C43.6692 19.4537 44.0009 19.6757 44.3663 19.8252C44.7317 19.9747 45.1234 20.0485 45.5178 20.0423C46.1384 20.0812 46.7531 19.9027 47.2575 19.5373C47.7618 19.1719 48.1245 18.6421 48.284 18.0381L49.9308 18.6135Z"
          fill="white"
        />
        <path
          d="M55.5789 11.5149H53.649V25.6605H55.5789V11.5149Z"
          fill="white"
        />
        <path
          d="M60.8281 18.2386C60.8912 18.7892 61.1677 19.2927 61.5975 19.64C62.0273 19.9873 62.576 20.1504 63.1247 20.094C64.2118 20.094 64.8036 19.4799 64.8036 18.801C64.8036 18.1222 64.3533 17.7084 63.5171 17.508L61.8317 17.1395C61.1557 17.0501 60.5351 16.7169 60.0854 16.2019C59.6357 15.687 59.3876 15.0253 59.3872 14.3401C59.3872 12.6527 60.9696 11.211 62.8995 11.211C65.6078 11.211 66.444 12.9824 66.6563 13.8682L64.9516 14.5147C64.8799 14.0303 64.6284 13.5911 64.2478 13.2853C63.8671 12.9795 63.3855 12.8297 62.8995 12.8661C62.5119 12.8221 62.1227 12.9331 61.8158 13.175C61.509 13.4169 61.309 13.7703 61.2591 14.1591C61.2591 14.7539 61.6258 15.187 62.3849 15.3551L63.9867 15.7042C65.7686 16.0986 66.7142 17.1912 66.7142 18.6523C66.7142 20.1134 65.5434 21.7233 63.1054 21.7233C60.3971 21.7233 59.2456 19.9712 59.0784 18.8398L60.8281 18.2386Z"
          fill="white"
        />
        <path
          d="M70.3874 11.5149H72.3173V21.4388H70.3874V11.5149ZM71.333 6.48502C71.5888 6.4786 71.8406 6.54893 72.0564 6.68705C72.2721 6.82516 72.442 7.02479 72.5444 7.26042C72.6467 7.49605 72.6768 7.75699 72.6308 8.0099C72.5849 8.26281 72.465 8.49622 72.2864 8.6803C72.1078 8.86438 71.8787 8.99077 71.6283 9.04334C71.3778 9.09591 71.1175 9.07226 70.8806 8.97542C70.6436 8.87858 70.4407 8.71293 70.2979 8.49965C70.155 8.28637 70.0787 8.03514 70.0786 7.77804C70.0785 7.44064 70.2096 7.11656 70.444 6.87498C70.6784 6.6334 70.9974 6.49346 71.333 6.48502Z"
          fill="white"
        />
        <path
          d="M78.5379 21.4388H76.608V11.5149H78.4993V12.9372C78.8037 12.4026 79.2471 11.9613 79.782 11.6606C80.3169 11.36 80.9231 11.2112 81.5356 11.2304C83.8965 11.2304 85.0673 12.9372 85.0673 15.1483V21.4388H83.1374V15.478C83.1374 14.0944 82.5585 12.9824 80.8409 12.9824C79.3227 12.9824 78.5379 14.1979 78.5379 15.7043V21.4388Z"
          fill="white"
        />
        <path
          d="M96.2476 16.1568C96.2476 14.2173 95.1026 12.9825 93.4364 12.9825C91.7703 12.9825 90.5867 14.2367 90.5867 16.1568C90.5867 18.077 91.6931 19.3312 93.4364 19.3312C95.1797 19.3312 96.2476 18.077 96.2476 16.1568ZM90.458 21.5358C90.509 22.2114 90.8167 22.8413 91.3173 23.2951C91.8179 23.7489 92.4731 23.9917 93.147 23.9731C95.2183 23.9731 96.1576 22.8999 96.1576 20.7406V19.3183C95.8538 19.8422 95.4119 20.2717 94.8807 20.5592C94.3494 20.8467 93.7494 20.981 93.147 20.9475C90.5159 20.9475 88.6118 18.9497 88.6118 16.1439C88.6118 13.4609 90.4323 11.3209 93.147 11.3209C94.6651 11.3209 95.6879 11.8963 96.1833 12.8855V11.5149H98.1132V20.6953C98.1132 23.2102 96.8845 25.6605 93.1727 25.6605C90.7089 25.6605 88.8626 24.096 88.6118 21.9689L90.458 21.5358Z"
          fill="white"
        />
        <path
          d="M104.244 21.4388H102.314V6.50443H104.244V12.6721C104.585 12.2001 105.037 11.821 105.561 11.5692C106.084 11.3175 106.662 11.201 107.241 11.2304C109.596 11.2304 110.767 12.9372 110.767 15.1483V21.4388H108.837V15.478C108.837 14.0945 108.264 12.9825 106.54 12.9825C105.061 12.9825 104.282 14.1332 104.244 15.6008V21.4388Z"
          fill="white"
        />
        <path
          d="M122.429 16.4671C122.429 14.1785 120.995 12.9372 119.348 12.9372C117.701 12.9372 116.273 14.1785 116.273 16.4671C116.273 18.7558 117.708 20.01 119.348 20.01C120.989 20.01 122.429 18.7752 122.429 16.4671ZM124.398 16.4671C124.398 19.4993 122.307 21.7427 119.348 21.7427C116.389 21.7427 114.305 19.4993 114.305 16.4671C114.305 13.435 116.395 11.211 119.348 11.211C122.301 11.211 124.359 13.4544 124.359 16.4671"
          fill="white"
        />
        <path
          d="M129.982 6.50443H128.052V21.4323H129.982V6.50443Z"
          fill="white"
        />
        <path
          d="M134.272 21.4388V11.5149H136.119V12.8079C136.435 12.3002 136.878 11.885 137.404 11.6036C137.93 11.3222 138.521 11.1846 139.116 11.2045C139.74 11.1801 140.355 11.3462 140.883 11.6809C141.41 12.0157 141.824 12.5033 142.069 13.0794C142.387 12.484 142.866 11.9915 143.452 11.6596C144.037 11.3276 144.704 11.1698 145.376 11.2045C147.1 11.2045 148.779 12.3812 148.779 14.9737V21.4388H146.849V15.2064C146.849 13.9134 146.205 12.9372 144.752 12.9372C144.436 12.9398 144.123 13.0077 143.835 13.1367C143.546 13.2658 143.287 13.4532 143.073 13.6873C142.859 13.9213 142.696 14.1971 142.593 14.4974C142.49 14.7977 142.45 15.1161 142.474 15.4327V21.4388H140.545V15.2064C140.545 13.9134 139.933 12.9372 138.454 12.9372C137.077 12.9372 136.157 13.9716 136.157 15.4586V21.4388H134.272Z"
          fill="white"
        />
        <path
          d="M54.5946 6.44623C54.8491 6.44623 55.0978 6.52206 55.3094 6.66414C55.521 6.80622 55.6859 7.00816 55.7833 7.24443C55.8806 7.4807 55.9061 7.74068 55.8565 7.9915C55.8068 8.24233 55.6843 8.47272 55.5044 8.65355C55.3244 8.83438 55.0952 8.95753 54.8456 9.00742C54.596 9.05731 54.3374 9.03171 54.1023 8.93384C53.8672 8.83598 53.6662 8.67025 53.5249 8.45761C53.3835 8.24498 53.308 7.99498 53.308 7.73925C53.308 7.39632 53.4436 7.06743 53.6849 6.82495C53.9262 6.58246 54.2534 6.44623 54.5946 6.44623Z"
          fill="white"
        />
        <path
          d="M22.3678 21.6557H9.3407V23.5517H22.3678V21.6557Z"
          fill="#FBFBFC"
        />
        <path
          d="M22.3678 15.1165H9.3407V17.0125H22.3678V15.1165Z"
          fill="#FBFBFC"
        />
        <path
          d="M22.3678 11.3696L15.8511 9.56389L9.3407 11.3696V9.4736L15.8511 7.66788L22.3678 9.4736V11.3696Z"
          fill="#FBFBFC"
        />
        <path
          d="M15.8766 1.90244C13.1117 1.89734 10.4075 2.72035 8.10619 4.26729C5.8049 5.81424 4.01001 8.01557 2.94871 10.5927C1.88742 13.1697 1.60744 16.0067 2.14421 18.7445C2.68097 21.4823 4.01036 23.9978 5.9641 25.9726C7.91783 27.9474 10.4081 29.2927 13.1196 29.8383C15.8312 30.3839 18.6421 30.1051 21.1967 29.0374C23.7513 27.9697 25.9346 26.161 27.4703 23.8402C29.006 21.5194 29.825 18.7909 29.8238 16C29.8187 12.266 28.3483 8.68613 25.7343 6.04399C23.1204 3.40185 19.5758 1.91268 15.8766 1.90244ZM15.8766 32C12.7405 32.0051 9.67335 31.071 7.06329 29.316C4.45324 27.561 2.41759 25.064 1.21394 22.1408C0.0102958 19.2176 -0.307256 15.9998 0.301471 12.8944C0.910199 9.78899 2.41785 6.93565 4.63364 4.69543C6.84943 2.45521 9.67377 0.928792 12.7493 0.309335C15.8248 -0.310122 19.0132 0.00522157 21.9111 1.21546C24.809 2.4257 27.2861 4.47644 29.029 7.10819C30.7718 9.73993 31.7021 12.8344 31.7021 16C31.6988 20.2379 30.0312 24.3017 27.0648 27.3008C24.0984 30.2999 20.0751 31.9897 15.8766 32Z"
          fill="#FBFBFC"
        />
      </g>
      <defs>
        <clipPath id="clip0_775_77040">
          <rect width="149" height="32" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
});

export const IconEnterKey = createIcon({
  displayName: "IconEnter",
  viewBox: "0 0 12 12",
  path: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8L7.5 8C8.875 8 10 6.901 10 5.5575L10 5.5725L10 3"
        stroke="currentColor"
      />
      <path d="M4.024 5.97607L2 8.00007L4.024 10.0241" stroke="currentColor" />
    </svg>
  ),
});

export const IconSearch = createIcon({
  displayName: "IconSearch",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8157 4.68927C9.1909 4.68927 7.63261 5.33473 6.48368 6.48365C5.33474 7.63257 4.68928 9.19085 4.68928 10.8157C4.68928 12.4405 5.33474 13.9988 6.48368 15.1477C7.63261 16.2966 9.1909 16.9421 10.8157 16.9421C12.4406 16.9421 13.9989 16.2966 15.1478 15.1477C16.2967 13.9988 16.9422 12.4405 16.9422 10.8157C16.9422 9.19085 16.2967 7.63257 15.1478 6.48365C13.9989 5.33473 12.4406 4.68927 10.8157 4.68927ZM16.3423 5.28916C14.8766 3.82343 12.8886 3 10.8157 3C8.74287 3 6.75491 3.82343 5.28918 5.28916C3.82344 6.75488 3 8.74283 3 10.8157C3 12.8885 3.82344 14.8765 5.28918 16.3422C6.75491 17.8079 8.74287 18.6313 10.8157 18.6313C12.8886 18.6313 14.8766 17.8079 16.3423 16.3422C17.808 14.8765 18.6315 12.8885 18.6315 10.8157C18.6315 8.74283 17.808 6.75488 16.3423 5.28916Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5799 15.5799C15.9097 15.2501 16.4445 15.2501 16.7744 15.5799L20.7526 19.5581C21.0825 19.888 21.0825 20.4228 20.7526 20.7526C20.4228 21.0825 19.888 21.0825 19.5581 20.7526L15.5799 16.7744C15.25 16.4446 15.25 15.9098 15.5799 15.5799Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconQuestion = createIcon({
  displayName: "IconQuestion",
  viewBox: "0 0 8 13",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17668 3.25669C4.86222 2.9414 4.44997 2.77919 4.02988 2.80543C4.00211 2.80717 3.97427 2.80738 3.94648 2.80608C3.5636 2.78819 3.1872 2.92171 2.88232 3.18359C2.57745 3.44546 2.36325 3.81924 2.27674 4.24032C2.16923 4.76363 1.70598 5.08954 1.24204 4.96828C0.778105 4.84701 0.489162 4.32449 0.59667 3.80119C0.773924 2.9384 1.21281 2.17255 1.83748 1.63598C2.4511 1.10891 3.20612 0.835596 3.97624 0.860844C4.8365 0.819334 5.67806 1.15673 6.32243 1.80279C6.97722 2.4593 7.37526 3.38126 7.4297 4.36752C7.43081 4.38765 7.43136 4.4078 7.43136 4.42796C7.43136 5.91355 6.47141 6.82796 5.87708 7.37299C5.79874 7.44484 5.72595 7.51072 5.6581 7.57213C5.42355 7.78442 5.24803 7.94327 5.10639 8.11022C4.99507 8.24143 4.96588 8.30989 4.9594 8.32975C4.95404 8.86172 4.57006 9.2911 4.09716 9.2911C3.62093 9.2911 3.23487 8.85564 3.23487 8.31847C3.23487 7.62063 3.57224 7.10495 3.86041 6.76529C4.08896 6.4959 4.38253 6.23113 4.62881 6.00901C4.68518 5.95817 4.73908 5.90956 4.78915 5.86364C5.41761 5.28731 5.6953 4.90859 5.70643 4.45647C5.67363 3.99488 5.48407 3.56488 5.17668 3.25669Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.2352 11.7227C3.2352 11.1855 3.62126 10.7501 4.09749 10.7501C4.65305 10.7501 5.1035 11.2581 5.1035 11.8848C5.1035 12.422 4.71744 12.8574 4.24121 12.8574C3.96647 12.8574 3.72175 12.7125 3.56384 12.4867C3.36368 12.3086 3.2352 12.0326 3.2352 11.7227Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconKeyCommand = createIcon({
  displayName: "IconKeyCommand",
  viewBox: "0 0 10 10",
  path: (
    <>
      <path
        d="M3.5 3.5H2C1.60218 3.5 1.22064 3.34196 0.93934 3.06066C0.658035 2.77936 0.5 2.39782 0.5 2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5C2.39782 0.5 2.77936 0.658035 3.06066 0.93934C3.34196 1.22064 3.5 1.60218 3.5 2V3.5Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 3.5H6.5V6.5H3.5V3.5Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 9.5C1.60218 9.5 1.22064 9.34196 0.93934 9.06066C0.658035 8.77936 0.5 8.39782 0.5 8C0.5 7.60218 0.658035 7.22064 0.93934 6.93934C1.22064 6.65804 1.60218 6.5 2 6.5H3.5V8C3.5 8.39782 3.34196 8.77936 3.06066 9.06066C2.77936 9.34196 2.39782 9.5 2 9.5Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 6.5H8C8.39782 6.5 8.77936 6.65804 9.06066 6.93934C9.34196 7.22064 9.5 7.60218 9.5 8C9.5 8.39782 9.34196 8.77936 9.06066 9.06066C8.77936 9.34196 8.39782 9.5 8 9.5C7.60218 9.5 7.22064 9.34196 6.93934 9.06066C6.65804 8.77936 6.5 8.39782 6.5 8V6.5Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 0.5C8.39782 0.5 8.77936 0.658035 9.06066 0.93934C9.34196 1.22064 9.5 1.60218 9.5 2C9.5 2.39782 9.34196 2.77936 9.06066 3.06066C8.77936 3.34196 8.39782 3.5 8 3.5H6.5V2C6.5 1.60218 6.65804 1.22064 6.93934 0.93934C7.22064 0.658035 7.60218 0.5 8 0.5Z"
        stroke="currentColor"
        fill="transparent"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const IconKeyG = createIcon({
  displayName: "IconKeyG",
  viewBox: "0 0 9 10",
  path: (
    <>
      <path
        d="M7.62014 3.17491C7.50687 2.85488 7.35755 2.56812 7.1722 2.31464C6.99027 2.05798 6.77231 1.83935 6.51831 1.65875C6.26773 1.47814 5.98284 1.3403 5.66362 1.24525C5.34439 1.15019 4.99428 1.10266 4.61327 1.10266C3.98856 1.10266 3.42048 1.25158 2.90904 1.54943C2.3976 1.84728 1.99085 2.28612 1.68879 2.86597C1.38673 3.44582 1.2357 4.15716 1.2357 5C1.2357 5.84284 1.38844 6.55418 1.69394 7.13403C1.99943 7.71388 2.41304 8.15273 2.93478 8.45057C3.45652 8.74842 4.04348 8.89734 4.69565 8.89734C5.29977 8.89734 5.83181 8.77852 6.29176 8.54087C6.75515 8.30006 7.11556 7.96103 7.373 7.52376C7.63387 7.08333 7.7643 6.56527 7.7643 5.96958L8.15561 6.04563H4.98398V5H9V6.04563C9 6.84728 8.81464 7.54436 8.44394 8.13688C8.07666 8.7294 7.56865 9.18885 6.91991 9.51521C6.2746 9.8384 5.53318 10 4.69565 10C3.76201 10 2.94165 9.79721 2.23455 9.39163C1.53089 8.98606 0.981693 8.40938 0.586956 7.6616C0.195652 6.91381 0 6.02662 0 5C0 4.23004 0.111556 3.53771 0.334668 2.923C0.561213 2.30513 0.880435 1.77915 1.29233 1.34506C1.70423 0.910964 2.19165 0.578264 2.75458 0.346958C3.31751 0.115653 3.93707 0 4.61327 0C5.16934 0 5.68764 0.0776299 6.16819 0.23289C6.65217 0.384981 7.08295 0.602028 7.46053 0.88403C7.84153 1.16286 8.15904 1.49715 8.41304 1.88688C8.66705 2.27345 8.8421 2.70279 8.93821 3.17491H7.62014Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconKeyE = createIcon({
  displayName: "IconKeyE",
  viewBox: "0 0 7 12",
  path: (
    <>
      <path
        d="M0 11.0909V0.909058H6.14489V2.00281H1.23295V5.44315H5.8267V6.5369H1.23295V9.99713H6.22443V11.0909H0Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconCase = createIcon({
  displayName: "IconCase",
  viewBox: "0 0 39 44",
  path: (
    <>
      <path
        d="M13.0003 4.125C12.7012 4.125 12.4587 4.36751 12.4587 4.66667V9C12.4587 9.29916 12.7012 9.54167 13.0003 9.54167H26.0003C26.2995 9.54167 26.542 9.29916 26.542 9V4.66667C26.542 4.36751 26.2995 4.125 26.0003 4.125H13.0003ZM9.20866 4.66667C9.20866 2.57259 10.9062 0.875 13.0003 0.875H26.0003C28.0944 0.875 29.792 2.57259 29.792 4.66667V9C29.792 11.0941 28.0944 12.7917 26.0003 12.7917H13.0003C10.9062 12.7917 9.20866 11.0941 9.20866 9V4.66667Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
      <path
        d="M6.50033 8.45833C5.78203 8.45833 5.09315 8.74368 4.58524 9.25159C4.07733 9.7595 3.79199 10.4484 3.79199 11.1667V37.1667C3.79199 37.885 4.07733 38.5738 4.58524 39.0818C5.09316 39.5897 5.78203 39.875 6.50033 39.875H32.5003C33.2186 39.875 33.9075 39.5897 34.4154 39.0818C34.9233 38.5738 35.2087 37.885 35.2087 37.1667V11.1667C35.2087 10.4484 34.9233 9.7595 34.4154 9.25159C33.9075 8.74368 33.2186 8.45833 32.5003 8.45833H28.167C27.2695 8.45833 26.542 7.7308 26.542 6.83333C26.542 5.93587 27.2695 5.20833 28.167 5.20833H32.5003C34.0806 5.20833 35.5961 5.83608 36.7135 6.95349C37.8309 8.07089 38.4587 9.58642 38.4587 11.1667V37.1667C38.4587 38.7469 37.8309 40.2624 36.7135 41.3798C35.5961 42.4972 34.0806 43.125 32.5003 43.125H6.50033C4.92008 43.125 3.40455 42.4972 2.28715 41.3798C1.16974 40.2624 0.541992 38.7469 0.541992 37.1667V11.1667C0.541992 9.58642 1.16974 8.07089 2.28715 6.95349C3.40455 5.83608 4.92008 5.20833 6.50033 5.20833H10.8337C11.7311 5.20833 12.4587 5.93587 12.4587 6.83333C12.4587 7.7308 11.7311 8.45833 10.8337 8.45833H6.50033Z"
        fill="currentColor"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </>
  ),
});

export const IconCases = createIcon({
  displayName: "IconCases",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.75C8.86193 3.75 8.75 3.86193 8.75 4V6C8.75 6.13807 8.86193 6.25 9 6.25H15C15.1381 6.25 15.25 6.13807 15.25 6V4C15.25 3.86193 15.1381 3.75 15 3.75H9ZM7.25 4C7.25 3.0335 8.0335 2.25 9 2.25H15C15.9665 2.25 16.75 3.0335 16.75 4V6C16.75 6.9665 15.9665 7.75 15 7.75H9C8.0335 7.75 7.25 6.9665 7.25 6V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5.75C5.66848 5.75 5.35054 5.8817 5.11612 6.11612C4.8817 6.35054 4.75 6.66848 4.75 7V19C4.75 19.3315 4.8817 19.6495 5.11612 19.8839C5.35054 20.1183 5.66848 20.25 6 20.25H18C18.3315 20.25 18.6495 20.1183 18.8839 19.8839C19.1183 19.6495 19.25 19.3315 19.25 19V7C19.25 6.66848 19.1183 6.35054 18.8839 6.11612C18.6495 5.8817 18.3315 5.75 18 5.75H16C15.5858 5.75 15.25 5.41421 15.25 5C15.25 4.58579 15.5858 4.25 16 4.25H18C18.7293 4.25 19.4288 4.53973 19.9445 5.05546C20.4603 5.57118 20.75 6.27065 20.75 7V19C20.75 19.7293 20.4603 20.4288 19.9445 20.9445C19.4288 21.4603 18.7293 21.75 18 21.75H6C5.27065 21.75 4.57118 21.4603 4.05546 20.9445C3.53973 20.4288 3.25 19.7293 3.25 19V7C3.25 6.27065 3.53973 5.57118 4.05546 5.05546C4.57118 4.53973 5.27065 4.25 6 4.25H8C8.41421 4.25 8.75 4.58579 8.75 5C8.75 5.41421 8.41421 5.75 8 5.75H6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6313 11.4697C14.9242 11.7626 14.9242 12.2374 14.6313 12.5303L12.1313 15.0303C11.8384 15.3232 11.3636 15.3232 11.0707 15.0303L9.57067 13.5303C9.27778 13.2374 9.27778 12.7626 9.57067 12.4697C9.86356 12.1768 10.3384 12.1768 10.6313 12.4697L11.601 13.4393L13.5707 11.4697C13.8636 11.1768 14.3384 11.1768 14.6313 11.4697Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconApartment = createIcon({
  displayName: "IconApartment",
  viewBox: "0 0 20 20",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3113 1.9361C10.6452 1.85799 10.9923 1.85581 11.3272 1.9297L15.4938 2.8497C15.4938 2.84969 15.4939 2.8497 15.4938 2.8497C16.0035 2.9622 16.4596 3.24534 16.7865 3.65225C17.1134 4.05918 17.2916 4.56553 17.2916 5.08751V14.9125C17.2916 15.4345 17.1134 15.9408 16.7865 16.3478C16.4596 16.7547 16.0036 17.0378 15.4939 17.1503C15.4939 17.1503 15.4939 17.1503 15.4939 17.1503L11.3272 18.0703C10.9925 18.1442 10.6454 18.142 10.3116 18.064C9.97781 17.986 9.66578 17.834 9.39849 17.6194C9.13121 17.4048 8.91547 17.1329 8.76718 16.8239C8.61889 16.5148 8.54182 16.1765 8.54165 15.8337V4.16751C8.54165 3.82463 8.61859 3.48611 8.76681 3.17691C8.91503 2.86772 9.13074 2.59572 9.39805 2.38097C9.66536 2.16622 9.97745 2.0142 10.3113 1.9361ZM11.0577 3.15032C10.9056 3.11674 10.7478 3.11774 10.596 3.15324C10.4443 3.18874 10.3024 3.25784 10.1809 3.35545C10.0594 3.45307 9.96136 3.5767 9.89399 3.71725C9.82662 3.85779 9.79165 4.01166 9.79165 4.16752V15.833C9.79172 15.9888 9.82676 16.1427 9.89416 16.2831C9.96157 16.4236 10.0596 16.5472 10.1811 16.6447C10.3026 16.7423 10.4445 16.8114 10.5962 16.8468C10.7479 16.8823 10.9056 16.8833 11.0577 16.8497C11.0577 16.8497 11.0577 16.8497 11.0577 16.8497L15.2244 15.9297C15.4561 15.8786 15.6634 15.7499 15.812 15.5649C15.9606 15.3799 16.0416 15.1498 16.0416 14.9125V5.08752C16.0416 4.85025 15.9606 4.62009 15.812 4.43513C15.6634 4.25016 15.4562 4.12146 15.2245 4.07033L11.0577 3.15032C11.0577 3.15032 11.0577 3.15031 11.0577 3.15032ZM3.37953 4.21289C3.8093 3.78312 4.39219 3.54168 4.99998 3.54168H6.66665C7.01182 3.54168 7.29165 3.8215 7.29165 4.16668C7.29165 4.51186 7.01182 4.79168 6.66665 4.79168H4.99998C4.72371 4.79168 4.45876 4.90143 4.26341 5.09678C4.06806 5.29213 3.95831 5.55708 3.95831 5.83335V14.1667C3.95831 14.4429 4.06806 14.7079 4.26341 14.9033C4.45876 15.0986 4.72371 15.2083 4.99998 15.2083H6.66665C7.01182 15.2083 7.29165 15.4882 7.29165 15.8333C7.29165 16.1785 7.01182 16.4583 6.66665 16.4583H4.99998C4.39219 16.4583 3.8093 16.2169 3.37953 15.7871C2.94976 15.3574 2.70831 14.7745 2.70831 14.1667V5.83335C2.70831 5.22556 2.94976 4.64267 3.37953 4.21289ZM11.6666 8.54168C12.0118 8.54168 12.2916 8.8215 12.2916 9.16668V10.8333C12.2916 11.1785 12.0118 11.4583 11.6666 11.4583C11.3215 11.4583 11.0416 11.1785 11.0416 10.8333V9.16668C11.0416 8.8215 11.3215 8.54168 11.6666 8.54168Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconProperty = createIcon({
  displayName: "IconProperty",
  viewBox: "0 0 20 20",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.56205 3.125H3.33335C3.10324 3.125 2.91669 3.31155 2.91669 3.54167V16.4583C2.91669 16.6885 3.10324 16.875 3.33336 16.875H9.97872V3.54167C9.97872 3.31155 9.79217 3.125 9.56205 3.125ZM3.33335 1.875C2.41288 1.875 1.66669 2.62119 1.66669 3.54167V16.4583C1.66669 17.3788 2.41288 18.125 3.33336 18.125H11.2287V3.54167C11.2287 2.62119 10.4825 1.875 9.56205 1.875H3.33335Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6666 7.85417H11.2305V16.875H16.6666C16.8967 16.875 17.0833 16.6885 17.0833 16.4583V8.27084C17.0833 8.04072 16.8967 7.85417 16.6666 7.85417ZM9.98049 6.60417V18.125H16.6666C17.5871 18.125 18.3333 17.3788 18.3333 16.4583V8.27084C18.3333 7.35036 17.5871 6.60417 16.6666 6.60417H9.98049Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15497 6.09375C2.15497 5.74857 2.43479 5.46875 2.77997 5.46875H9.98049C10.3257 5.46875 10.6055 5.74857 10.6055 6.09375C10.6055 6.43893 10.3257 6.71875 9.98049 6.71875H2.77997C2.43479 6.71875 2.15497 6.43893 2.15497 6.09375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15497 10C2.15497 9.65482 2.43479 9.375 2.77997 9.375H9.98049C10.3257 9.375 10.6055 9.65482 10.6055 10C10.6055 10.3452 10.3257 10.625 9.98049 10.625H2.77997C2.43479 10.625 2.15497 10.3452 2.15497 10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15497 13.9063C2.15497 13.5611 2.43479 13.2813 2.77997 13.2813H9.98049C10.3257 13.2813 10.6055 13.5611 10.6055 13.9063C10.6055 14.2514 10.3257 14.5313 9.98049 14.5313H2.77997C2.43479 14.5313 2.15497 14.2514 2.15497 13.9063Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6919 10.6458C11.6919 10.3007 11.9717 10.0208 12.3169 10.0208H15.9969C16.3421 10.0208 16.6219 10.3007 16.6219 10.6458C16.6219 10.991 16.3421 11.2708 15.9969 11.2708H12.3169C11.9717 11.2708 11.6919 10.991 11.6919 10.6458Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6919 13.1979C11.6919 12.8527 11.9717 12.5729 12.3169 12.5729H15.9969C16.3421 12.5729 16.6219 12.8527 16.6219 13.1979C16.6219 13.5431 16.3421 13.8229 15.9969 13.8229H12.3169C11.9717 13.8229 11.6919 13.5431 11.6919 13.1979Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconTenant = createIcon({
  displayName: "IconTenant",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2025 3.25009C16.241 3.23422 17.2433 3.63143 17.9889 4.35437C18.7346 5.07731 19.1626 6.06679 19.1789 7.10525L19.179 7.12191C19.1721 8.17529 18.7586 9.18532 18.0249 9.94118C17.2912 10.697 16.2939 11.1403 15.2412 11.1785C14.8272 11.1935 14.4795 10.8701 14.4645 10.4562C14.4495 10.0422 14.7729 9.69451 15.1868 9.6795C15.8531 9.65533 16.4843 9.37478 16.9486 8.8964C17.411 8.42002 17.6725 7.78413 17.6789 7.12046C17.6668 6.48271 17.4029 5.87548 16.9448 5.43131C16.4847 4.98522 15.8662 4.74012 15.2255 4.74992C14.8113 4.75625 14.4704 4.42563 14.4641 4.01146C14.4578 3.5973 14.7884 3.25642 15.2025 3.25009Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.42912 3.24993C8.3947 3.23712 7.39702 3.63406 6.65407 4.35437C5.9084 5.07731 5.48037 6.06679 5.46409 7.10525L5.46402 7.12169C5.4706 8.17523 5.88397 9.18548 6.6178 9.94145C7.35163 10.6974 8.34915 11.1406 9.40203 11.1785C9.42015 11.1792 9.43829 11.1792 9.45641 11.1785C10.5089 11.14 11.5059 10.6966 12.2394 9.94076C12.9728 9.18494 13.3861 8.17508 13.393 7.1219L13.3929 7.10525C13.3766 6.06701 12.9488 5.07771 12.2034 4.35481C11.4607 3.63453 10.4633 3.23745 9.42912 3.24993ZM9.41754 4.74992C8.77675 4.74012 8.1583 4.98522 7.69819 5.43131C7.24003 5.87551 6.9762 6.48277 6.96405 7.12057C6.97031 7.78427 7.23165 8.42027 7.6941 8.89667C8.15215 9.36853 8.77255 9.64784 9.42878 9.67837C10.0849 9.64746 10.705 9.36799 11.1629 8.89615C11.6252 8.41979 11.8865 7.784 11.8929 7.12046C11.8808 6.48284 11.617 5.87573 11.1591 5.43159C10.6991 4.98552 10.0809 4.74033 9.44022 4.74992C9.43266 4.75003 9.4251 4.75003 9.41754 4.74992Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64124 14.6412C4.53204 13.7504 5.74022 13.25 7 13.25H12C13.2598 13.25 14.468 13.7504 15.3588 14.6412C16.2496 15.532 16.75 16.7402 16.75 18V20C16.75 20.4142 16.4142 20.75 16 20.75C15.5858 20.75 15.25 20.4142 15.25 20V18C15.25 17.1381 14.9076 16.3114 14.2981 15.7019C13.6886 15.0924 12.862 14.75 12 14.75H7C6.13805 14.75 5.3114 15.0924 4.7019 15.7019C4.09241 16.3114 3.75 17.1381 3.75 18V20C3.75 20.4142 3.41421 20.75 3 20.75C2.58579 20.75 2.25 20.4142 2.25 20V18C2.25 16.7402 2.75044 15.532 3.64124 14.6412Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 14C17.25 13.5858 17.5858 13.25 18 13.25C18.9946 13.25 19.9484 13.6451 20.6517 14.3484C21.3549 15.0516 21.75 16.0054 21.75 17V20C21.75 20.4142 21.4142 20.75 21 20.75C20.5858 20.75 20.25 20.4142 20.25 20V17C20.25 16.4033 20.0129 15.831 19.591 15.409C19.169 14.9871 18.5967 14.75 18 14.75C17.5858 14.75 17.25 14.4142 17.25 14Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconUser = createIcon({
  displayName: "IconUser",
  viewBox: "2.67 1.83 10.67 13.33",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94769 1.8336C7.18674 1.82384 6.45282 2.12626 5.90628 2.67506C5.35774 3.22586 5.04287 3.97973 5.03089 4.77093L5.03084 4.78345C5.03568 5.58613 5.33977 6.35583 5.8796 6.93179C6.41942 7.50776 7.15324 7.84543 7.92777 7.8743C7.9411 7.8748 7.95444 7.87479 7.96777 7.87429C8.74203 7.84496 9.47544 7.50713 10.015 6.93127C10.5546 6.35541 10.8586 5.58602 10.8636 4.78361L10.8636 4.77092C10.8516 3.9799 10.5369 3.22616 9.98852 2.67539C9.44218 2.12663 8.70849 1.82409 7.94769 1.8336ZM7.93918 2.97642C7.46779 2.96896 7.01284 3.1557 6.67437 3.49557C6.33733 3.834 6.14325 4.29667 6.13431 4.7826C6.13892 5.28826 6.33117 5.77282 6.67136 6.13579C7.00832 6.4953 7.4647 6.7081 7.94745 6.73135C8.43008 6.70781 8.88629 6.49488 9.22312 6.13539C9.56317 5.77246 9.75541 5.28806 9.76017 4.78252C9.7512 4.29672 9.55721 3.83417 9.22031 3.49578C8.88196 3.15593 8.42715 2.96912 7.95586 2.97643C7.9503 2.97651 7.94474 2.97651 7.93918 2.97642Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68995 10.5125C4.34525 9.83383 5.23402 9.45254 6.16076 9.45254H9.83892C10.7656 9.45254 11.6544 9.83383 12.3097 10.5125C12.965 11.1912 13.3332 12.1117 13.3332 13.0715V14.5953C13.3332 14.9109 13.0862 15.1667 12.7814 15.1667C12.4767 15.1667 12.2297 14.9109 12.2297 14.5953V13.0715C12.2297 12.4148 11.9778 11.785 11.5295 11.3206C11.0811 10.8563 10.473 10.5954 9.83892 10.5954H6.16076C5.52668 10.5954 4.91857 10.8563 4.4702 11.3206C4.02184 11.785 3.76995 12.4148 3.76995 13.0715V14.5953C3.76995 14.9109 3.52294 15.1667 3.21823 15.1667C2.91352 15.1667 2.6665 14.9109 2.6665 14.5953V13.0715C2.6665 12.1117 3.03465 11.1912 3.68995 10.5125Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconFileAttachment = createIcon({
  displayName: "IconFileAttachment",
  viewBox: "0 0 18 18",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.54686 5.3042C7.93351 4.92609 8.45282 4.71436 8.99362 4.71436C9.53443 4.71436 10.0537 4.92609 10.4404 5.3042C10.827 5.68232 11.0503 6.19678 11.0624 6.73745L11.0625 6.75V12.75C11.0625 13.0607 10.8107 13.3125 10.5 13.3125C10.1893 13.3125 9.9375 13.0607 9.9375 12.75V6.757C9.9306 6.51231 9.82894 6.27977 9.65382 6.10852C9.47738 5.93598 9.24041 5.83936 8.99362 5.83936C8.74684 5.83936 8.50987 5.93598 8.33343 6.10852C8.15831 6.27977 8.05665 6.51231 8.04975 6.757V12C8.04975 12.3107 7.79791 12.5625 7.48725 12.5625C7.17659 12.5625 6.92475 12.3107 6.92475 12V6.75L6.92489 6.73745C6.93695 6.19678 7.16021 5.68232 7.54686 5.3042Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 5.4375C5.56066 5.4375 5.8125 5.68934 5.8125 6V12.7875C5.8125 13.0982 5.56066 13.35 5.25 13.35C4.93934 13.35 4.6875 13.0982 4.6875 12.7875V6C4.6875 5.68934 4.93934 5.4375 5.25 5.4375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.75 5.4375C13.0607 5.4375 13.3125 5.68934 13.3125 6V11.25C13.3125 11.5607 13.0607 11.8125 12.75 11.8125C12.4393 11.8125 12.1875 11.5607 12.1875 11.25V6C12.1875 5.68934 12.4393 5.4375 12.75 5.4375Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 12.1875C5.56066 12.1875 5.8125 12.4393 5.8125 12.75V13.125C5.8125 13.672 6.0298 14.1966 6.41659 14.5834C6.80339 14.9702 7.32799 15.1875 7.875 15.1875C8.42201 15.1875 8.94661 14.9702 9.33341 14.5834C9.7202 14.1966 9.9375 13.672 9.9375 13.125V12.75C9.9375 12.4393 10.1893 12.1875 10.5 12.1875C10.8107 12.1875 11.0625 12.4393 11.0625 12.75V13.125C11.0625 13.9704 10.7267 14.7811 10.1289 15.3789C9.53113 15.9767 8.72038 16.3125 7.875 16.3125C7.02962 16.3125 6.21887 15.9767 5.6211 15.3789C5.02333 14.7811 4.6875 13.9704 4.6875 13.125V12.75C4.6875 12.4393 4.93934 12.1875 5.25 12.1875Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.9506 2.9506C6.75935 2.14185 7.85625 1.6875 9 1.6875C10.1437 1.6875 11.2406 2.14185 12.0494 2.9506C12.8581 3.75935 13.3125 4.85625 13.3125 6C13.3125 6.31066 13.0607 6.5625 12.75 6.5625C12.4393 6.5625 12.1875 6.31066 12.1875 6C12.1875 5.15462 11.8517 4.34387 11.2539 3.7461C10.6561 3.14832 9.84538 2.8125 9 2.8125C8.15462 2.8125 7.34387 3.14832 6.7461 3.7461C6.14832 4.34387 5.8125 5.15462 5.8125 6C5.8125 6.31066 5.56066 6.5625 5.25 6.5625C4.93934 6.5625 4.6875 6.31066 4.6875 6C4.6875 4.85625 5.14185 3.75935 5.9506 2.9506Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconOptions = createIcon({
  displayName: "IconOptions",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66666 12.6722C6.6615 11.9284 7.26629 11.3333 7.99798 11.3333C8.7317 11.3333 9.33331 11.9272 9.33331 12.6667C9.33331 13.4023 8.7356 14 7.99998 14C7.26619 14 6.66962 13.4053 6.66666 12.6722Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66666 8.00549C6.6615 7.26177 7.26629 6.66667 7.99798 6.66667C8.7317 6.66667 9.33331 7.26049 9.33331 8C9.33331 8.73562 8.7356 9.33333 7.99998 9.33333C7.26619 9.33333 6.66962 8.73859 6.66666 8.00549Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66666 3.33882C6.6615 2.5951 7.26629 2 7.99798 2C8.7317 2 9.33331 2.59383 9.33331 3.33333C9.33331 4.06895 8.7356 4.66667 7.99998 4.66667C7.26619 4.66667 6.66962 4.07192 6.66666 3.33882Z"
        fill="black"
      />
    </>
  ),
});

export const IconEditPen = createIcon({
  displayName: "IconEditPen",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7658 3.88252L3.88214 10.7662L3.88119 10.7672C3.85073 10.7975 3.83325 10.839 3.83325 10.8833V12.1667H5.11659C5.13812 12.1667 5.15988 12.1624 5.17977 12.1542C5.19966 12.1459 5.21772 12.1338 5.23291 12.1186L5.23373 12.1177L12.1181 5.23474C12.1491 5.20351 12.1668 5.16105 12.1668 5.11699C12.1668 5.07287 12.1493 5.03055 12.1181 4.99931L11.0013 3.88252C10.9701 3.85138 10.9277 3.8338 10.8836 3.8338C10.8395 3.8338 10.7971 3.85136 10.7658 3.88252ZM10.0593 3.1748C10.2781 2.95644 10.5745 2.8338 10.8836 2.8338C11.1927 2.8338 11.4891 2.95644 11.7078 3.1748L12.8255 4.29244C13.0438 4.51117 13.1668 4.80792 13.1668 5.11699C13.1668 5.42606 13.0441 5.72251 12.8258 5.94124L5.94159 12.8241C5.83348 12.9326 5.70454 13.0191 5.56308 13.0778C5.42142 13.1366 5.26953 13.1668 5.11615 13.1667H3.33325C3.05711 13.1667 2.83325 12.9428 2.83325 12.6667V10.8833C2.83325 10.5746 2.95558 10.2777 3.17545 10.0587L3.17598 10.0582L10.0593 3.1748Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81303 4.41977C9.00829 4.22451 9.32488 4.22451 9.52014 4.41977L11.5801 6.47977C11.7754 6.67503 11.7754 6.99162 11.5801 7.18688C11.3849 7.38214 11.0683 7.38214 10.873 7.18688L8.81303 5.12688C8.61777 4.93162 8.61777 4.61503 8.81303 4.41977Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconTrashCan = createIcon({
  displayName: "IconTrashCan",
  viewBox: "0 0 16 16",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.5C4.27614 3.5 4.5 3.72386 4.5 4V12.5038C4.49901 12.6342 4.5238 12.7635 4.57299 12.8843C4.62217 13.005 4.69476 13.1149 4.78657 13.2075C4.87838 13.3 4.9876 13.3736 5.10795 13.4238C5.22829 13.474 5.35737 13.4999 5.48777 13.5H10.4873C11.0448 13.5 11.5 13.0469 11.5 12.5V4C11.5 3.72386 11.7239 3.5 12 3.5C12.2761 3.5 12.5 3.72386 12.5 4V12.5C12.5 13.6104 11.5858 14.5 10.4873 14.5H5.48733C5.22505 14.4998 4.96497 14.4477 4.7229 14.3467C4.48084 14.2457 4.26115 14.0978 4.07647 13.9116C3.8918 13.7253 3.74579 13.5044 3.64686 13.2615C3.54818 13.0192 3.49828 12.7598 3.5 12.4982V4C3.5 3.72386 3.72386 3.5 4 3.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 4C2.5 3.72386 2.72386 3.5 3 3.5H13C13.2761 3.5 13.5 3.72386 13.5 4C13.5 4.27614 13.2761 4.5 13 4.5H3C2.72386 4.5 2.5 4.27614 2.5 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16667 2C6.16667 1.72386 6.39052 1.5 6.66667 1.5H9.33333C9.60948 1.5 9.83333 1.72386 9.83333 2C9.83333 2.27614 9.60948 2.5 9.33333 2.5H6.66667C6.39052 2.5 6.16667 2.27614 6.16667 2Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33333 6.16667C9.60948 6.16667 9.83333 6.39052 9.83333 6.66667V11.3333C9.83333 11.6095 9.60948 11.8333 9.33333 11.8333C9.05719 11.8333 8.83333 11.6095 8.83333 11.3333V6.66667C8.83333 6.39052 9.05719 6.16667 9.33333 6.16667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66667 6.16667C6.94281 6.16667 7.16667 6.39052 7.16667 6.66667V11.3333C7.16667 11.6095 6.94281 11.8333 6.66667 11.8333C6.39052 11.8333 6.16667 11.6095 6.16667 11.3333V6.66667C6.16667 6.39052 6.39052 6.16667 6.66667 6.16667Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconNote = createIcon({
  displayName: "IconNote",
  viewBox: "0 0 32 32",
  path: (
    <>
      <path
        d="M5.49022 25.8824H19.1373V20.8235C19.1373 19.719 20.0327 18.8235 21.1373 18.8235H26.9804V6.54118C26.9804 6.42353 26.9349 6.32376 26.8439 6.24188C26.7519 6.15906 26.6405 6.11765 26.5098 6.11765H5.49022C5.3595 6.11765 5.24865 6.15906 5.15767 6.24188C5.06564 6.32376 5.01963 6.42353 5.01963 6.54118V25.4588C5.01963 25.5765 5.06564 25.6767 5.15767 25.7595C5.24865 25.8414 5.3595 25.8824 5.49022 25.8824ZM5.49022 28C4.7059 28 4.03924 27.7529 3.49022 27.2588C2.9412 26.7647 2.66669 26.1647 2.66669 25.4588V6.54118C2.66669 5.83529 2.9412 5.23529 3.49022 4.74118C4.03924 4.24706 4.7059 4 5.49022 4H26.5098C27.2941 4 27.9608 4.24706 28.5098 4.74118C29.0588 5.23529 29.3334 5.83529 29.3334 6.54118V19.2958C29.3334 19.5793 29.213 19.8495 29.0023 20.0391L20.4421 27.7433C20.2585 27.9086 20.0202 28 19.7731 28H5.49022ZM9.86277 18.4353C9.31048 18.4353 8.86277 17.9876 8.86277 17.4353V17.3176C8.86277 16.7654 9.31048 16.3176 9.86277 16.3176H15C15.5523 16.3176 16 16.7654 16 17.3176V17.4353C16 17.9876 15.5523 18.4353 15 18.4353H9.86277ZM9.86277 12.8235C9.31048 12.8235 8.86277 12.3758 8.86277 11.8235V11.7059C8.86277 11.1536 9.31048 10.7059 9.86277 10.7059H22.1373C22.6896 10.7059 23.1373 11.1536 23.1373 11.7059V11.8235C23.1373 12.3758 22.6896 12.8235 22.1373 12.8235H9.86277Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconClose = createIcon({
  displayName: "IconClose",
  viewBox: "0 0 18 19",
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8977 4.60225C14.1174 4.82192 14.1174 5.17808 13.8977 5.39775L4.89775 14.3977C4.67808 14.6174 4.32192 14.6174 4.10225 14.3977C3.88258 14.1781 3.88258 13.8219 4.10225 13.6023L13.1023 4.60225C13.3219 4.38258 13.6781 4.38258 13.8977 4.60225Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.10225 4.60225C4.32192 4.38258 4.67808 4.38258 4.89775 4.60225L13.8977 13.6023C14.1174 13.8219 14.1174 14.1781 13.8977 14.3977C13.6781 14.6174 13.3219 14.6174 13.1023 14.3977L4.10225 5.39775C3.88258 5.17808 3.88258 4.82192 4.10225 4.60225Z"
        fill="currentColor"
      />
    </>
  ),
});

export const IconAttachmentRemove = createIcon({
  displayName: "IconAttachmentRemove",
  viewBox: "0 0 16 16",
  path: (
    <>
      <circle cx="8" cy="8" stroke="currentColor" r="7" fill="none" />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.177 5.823a.25.25 0 0 1 0 .354l-4 4a.25.25 0 0 1-.354-.354l4-4a.25.25 0 0 1 .354 0Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M5.823 5.823a.25.25 0 0 1 .354 0l4 4a.25.25 0 0 1-.354.354l-4-4a.25.25 0 0 1 0-.354Z"
        clipRule="evenodd"
      />
    </>
  ),
});

export const IconPdf = createIcon({
  displayName: "IconPdf",
  viewBox: "0 0 20 20",
  path: (
    <path
      d="M3.33325 17.5V13.75H4.99992C5.33144 13.75 5.64938 13.8817 5.8838 14.1161C6.11822 14.3505 6.24992 14.6685 6.24992 15C6.24992 15.3315 6.11822 15.6495 5.8838 15.8839C5.64938 16.1183 5.33144 16.25 4.99992 16.25H3.33325M15.4166 15.9583H13.3333M15.8333 13.75H13.3333V17.5M16.6666 10.8333V7.01167C16.6665 6.79067 16.5787 6.57874 16.4224 6.4225L12.7441 2.74417C12.5878 2.58788 12.3759 2.50005 12.1549 2.5H4.99992C4.55789 2.5 4.13397 2.67559 3.82141 2.98816C3.50885 3.30072 3.33325 3.72464 3.33325 4.16667V10.8333M16.6666 7.5H13.3333C12.8912 7.5 12.4673 7.3244 12.1547 7.01184C11.8422 6.69928 11.6666 6.27536 11.6666 5.83333V2.5M8.33325 13.75H9.58325C10.0253 13.75 10.4492 13.9256 10.7618 14.2382C11.0743 14.5507 11.2499 14.9746 11.2499 15.4167V15.8333C11.2499 16.2754 11.0743 16.6993 10.7618 17.0118C10.4492 17.3244 10.0253 17.5 9.58325 17.5H8.33325V13.75Z"
      strokeWidth="1.25"
      stroke="#0C738E"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
